(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dogheroes--announcement-bar"] && !Shopify.designMode) return;
  try {
    window.DogHeroes = window.DogHeroes || {}
  ;(() => {
    // Resolve the effective discount percentage once and store it on DogHeroes
    // so every controller on the page reads from a single source of truth.
    //
    // Priority (highest → lowest):
    //   1. URL hash `#discount=<n>`  — saved to localStorage with a TTL so it
    //      carries forward automatically from /pages/quiz to /pages/recipes
    //      even after the hash is no longer in the URL.
    //   2. Unexpired value in localStorage (set by a previous page in the flow).
    //   3. Metaobject value (server-side default).

    const STORAGE_KEY = 'dogheroes.discount_override'
    const TTL_MS = 24 * 60 * 60 * 1000 // 24 hours

    const bar = document.querySelector('[data-announcement-discount-value]')
    const metaobjectDiscount = Number.parseFloat(bar?.dataset.announcementDiscountValue || '40')

    // --- 1. Check URL hash ---
    let discount = null
    const hash = window.location?.hash || ''
    if (hash && hash.length > 1) {
      const hashParams = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash)
      const discountParam = hashParams.get('discount')
      if (discountParam != null && discountParam.trim() !== '') {
        const parsed = Number.parseFloat(discountParam)
        if (Number.isFinite(parsed) && parsed >= 0 && parsed <= 100) {
          discount = parsed
          // Persist so the next page in the flow (e.g. /pages/recipes) can use it.
          try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify({ value: discount, expires: Date.now() + TTL_MS }))
          } catch (_) {}
        }
      }
    }

    // --- 2. Fall back to stored value if not expired ---
    if (discount === null) {
      try {
        const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null')
        if (stored && Number.isFinite(stored.value) && Date.now() < stored.expires) {
          discount = stored.value
        } else if (stored) {
          localStorage.removeItem(STORAGE_KEY)
        }
      } catch (_) {}
    }

    // --- 3. Fall back to metaobject value ---
    if (discount === null) discount = metaobjectDiscount

    // Single source of truth — all controllers read this.
    window.DogHeroes.discountPercentage = discount

    if (!bar) return

    bar.dataset.announcementDiscountValue = String(discount)

    // Fallback text: update the explicit <span data-announcement-discount>.
    const span = bar.querySelector('[data-announcement-discount]')
    if (span) {
      span.textContent = String(discount)
      return
    }

    // Metaobject rich text: find and replace the first `<number>%` or `<number> %`
    // in a text node — only when the resolved value differs from the server default.
    if (discount === metaobjectDiscount) return

    const walker = document.createTreeWalker(bar, NodeFilter.SHOW_TEXT)
    const percentPattern = /(\d+)(\s*%)/
    let node
    while ((node = walker.nextNode())) {
      if (percentPattern.test(node.nodeValue)) {
        node.nodeValue = node.nodeValue.replace(percentPattern, `${discount}$2`)
        break
      }
    }
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--dogs--form"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'weight-validation',
    class extends Stimulus.Controller {
      static targets = ['weight', 'alert']
      static values = { maxWeight: 200, alertThreshold: 100 }

      validateWeight() {
        const input = this.weightTarget

        // Limit to at most 2 decimal places without rounding (truncate extra digits)
        const dotIndex = input.value.indexOf('.')
        if (dotIndex !== -1 && input.value.length - dotIndex - 1 > 2) {
          input.value = input.value.slice(0, dotIndex + 3)
        }

        const weight = parseFloat(input.value)

        // Nothing entered yet (or an in-progress value like "12."): leave it alone
        if (Number.isNaN(weight)) {
          this.alertTarget.style.display = 'none'
          return
        }

        // Cap weight at max limit and show alert banner if exceeded
        if (weight > this.maxWeightValue) {
          input.value = this.maxWeightValue
          this.alertTarget.style.display = 'block'
        } else if (weight > this.alertThresholdValue) {
          this.alertTarget.style.display = 'block'
        } else {
          this.alertTarget.style.display = 'none'
        }
      }
    }
  )

  // Track form dirty state and manage loading state
  const form = document.getElementById('dog-form')
  const submitBtn = document.getElementById('dog-form-preview-button')
  const sticky = submitBtn?.closest('.sticky')
  const previewDialog = document.getElementById('dog-form-preview-dialog')
  const previewContent = document.getElementById('dog-form-preview-content')
  const previewLoading = previewContent?.querySelector('.dog-form-preview-loading')
  const previewError = previewContent?.querySelector('.dog-form-preview-error')
  const previewBody = previewContent?.querySelector('.dog-form-preview-body')
  const previewConfirmBtn = previewDialog?.querySelector('[data-dialog-confirm]')

  // Fields whose changes don't impact the meal plan calculation, so we can
  // skip the preview dialog and submit the form directly.
  const SAFE_FIELDS = new Set([
    'dog[name]',
    'dog[hunger]',
    'dog[allergies]',
    'dog[allergies][]',
    'dog[diseases]',
    'dog[diseases][]',
    'dog[has_diseases]',
    // Derived field, updated client-side from the other inputs; safe by definition.
    'dog[daily_calories]',
  ])
  // Age fields are safe only when the dog is older than 15 months in both the
  // initial and the current state (puppy calorie formulas differ).
  const AGE_FIELDS = new Set(['dog[birthday]', 'dog[birthday_type]'])
  const PUPPY_MONTHS_THRESHOLD = 15

  if (form && submitBtn) {
    // The body-condition deprecation notice is only rendered when the dog's
    // saved build is deprecated. Hide it as soon as the user moves the slider
    // to another value, and show it again if they return to the deprecated one.
    const deprecationNotice = form.querySelector('.field-deprecation-notice')
    if (deprecationNotice) {
      const buildInput = form.querySelector('input[name="dog[build]"]')
      const buildSlider = buildInput?.closest('range-slider')
      if (buildInput && buildSlider) {
        const deprecatedHandle = deprecationNotice.dataset.deprecatedHandle
        // The slider updates its hidden input synchronously before these events
        // bubble up to the range-slider element (native `input` on drag, `click`
        // on a marker), so the value is already current when we read it.
        const syncDeprecationNotice = () => {
          deprecationNotice.hidden = buildInput.value !== deprecatedHandle
        }
        buildSlider.addEventListener('input', syncDeprecationNotice)
        buildSlider.addEventListener('click', syncDeprecationNotice)
      }
    }

    const currentEntries = () => Array.from(new FormData(form).entries()).map(([name, value]) => [name, String(value)])

    // Serialize as normalized FormData so radio groups and multi-value fields compare correctly.
    const serializeEntries = (entries) =>
      JSON.stringify(
        [...entries].sort((a, b) => {
          if (a[0] !== b[0]) return a[0].localeCompare(b[0])
          return a[1].localeCompare(b[1])
        })
      )

    let initialEntries = []
    let initialState = ''

    // Check if form state differs from initial state
    const updateDirtyState = () => {
      const hasChanges = serializeEntries(currentEntries()) !== initialState
      submitBtn.disabled = !hasChanges
    }

    // Some controls are hydrated after initial render; snapshot after the form settles.
    const captureInitialState = () => {
      initialEntries = currentEntries()
      initialState = serializeEntries(initialEntries)
      updateDirtyState()
    }

    // Group entries by field name so multi-value fields (checkboxes) compare correctly.
    const groupEntries = (entries) => {
      const map = new Map()
      for (const [name, value] of entries) {
        if (!map.has(name)) map.set(name, [])
        map.get(name).push(value)
      }
      for (const values of map.values()) values.sort()
      return map
    }

    const changedFieldNames = (oldEntries, newEntries) => {
      const oldMap = groupEntries(oldEntries)
      const newMap = groupEntries(newEntries)
      const names = new Set([...oldMap.keys(), ...newMap.keys()])
      const changed = []
      for (const name of names) {
        const a = (oldMap.get(name) || []).join('|')
        const b = (newMap.get(name) || []).join('|')
        if (a !== b) changed.push(name)
      }
      return changed
    }

    const buildDogFromEntries = (entries) => {
      const attrs = {}
      for (const [name, value] of entries) {
        const match = name.match(/^dog\[([^\]]+)\]/)
        if (!match) continue
        const key = match[1]
        if (key in attrs) {
          attrs[key] = [].concat(attrs[key], value)
        } else {
          attrs[key] = value
        }
      }
      return new DogHeroes.Dog(attrs)
    }

    // Returns true when every changed field can skip the meal plan preview.
    const canSkipPreview = () => {
      const changed = changedFieldNames(initialEntries, currentEntries())
      if (changed.length === 0) return false
      const allSafe = changed.every((name) => SAFE_FIELDS.has(name) || AGE_FIELDS.has(name))
      if (!allSafe) return false
      const ageChanged = changed.some((name) => AGE_FIELDS.has(name))
      if (ageChanged) {
        const oldMonths = buildDogFromEntries(initialEntries).age?.inMonths ?? 0
        const newMonths = buildDogFromEntries(currentEntries()).age?.inMonths ?? 0
        if (oldMonths <= PUPPY_MONTHS_THRESHOLD || newMonths <= PUPPY_MONTHS_THRESHOLD) {
          return false
        }
      }
      return true
    }

    // Recompute the derived daily_calories hidden field from the current form
    // state so it is always in sync when the form is submitted.
    const dailyCaloriesInput = document.getElementById('dog-daily-calories')
    const updateDailyCalories = () => {
      if (!dailyCaloriesInput) return
      const dog = buildDogFromEntries(currentEntries())
      const value = Math.round(dog.dailyCalories() || 0)
      dailyCaloriesInput.value = String(value)
    }

    // Update dirty state on any input or change
    form.addEventListener('input', () => {
      updateDailyCalories()
      updateDirtyState()
    })
    form.addEventListener('change', () => {
      updateDailyCalories()
      updateDirtyState()
    })

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        updateDailyCalories()
        captureInitialState()
      })
    })

    // Toggle loading state on form submit (real submission triggered from the dialog confirm button).
    form.addEventListener('submit', () => {
      if (sticky) {
        sticky.setAttribute('data-loading', '')
      }
      submitBtn.disabled = true
      const cancelLink = sticky?.querySelector('.dh-button-secondary')
      if (cancelLink) cancelLink.style.pointerEvents = 'none'
    })

    // Fetch preview HTML when the user opens the dialog.
    if (previewDialog && previewContent && previewBody && previewLoading && previewError) {
      let currentRequestToken = 0

      const showLoading = () => {
        previewLoading.hidden = false
        previewError.hidden = true
        previewBody.hidden = true
        previewBody.innerHTML = ''
        if (previewConfirmBtn) previewConfirmBtn.disabled = true
      }

      const showError = () => {
        previewLoading.hidden = true
        previewError.hidden = false
        previewBody.hidden = true
        if (previewConfirmBtn) previewConfirmBtn.disabled = true
      }

      const showBody = (html) => {
        previewBody.innerHTML = html
        previewLoading.hidden = true
        previewError.hidden = true
        previewBody.hidden = false
        if (previewConfirmBtn) previewConfirmBtn.disabled = false
      }

      submitBtn.addEventListener('click', async (event) => {
        if (submitBtn.disabled) return

        // If only fields that don't impact the meal plan have changed, skip
        // the preview dialog entirely and submit the form directly.
        if (canSkipPreview()) {
          event.preventDefault()
          event.stopImmediatePropagation()
          form.requestSubmit()
          return
        }

        const url = submitBtn.dataset.previewUrl
        if (!url) return

        const token = ++currentRequestToken
        showLoading()

        // Build a Dog instance from the form fields so we can reuse the
        // existing client-side calorie calculation (see assets/dogheroes--dog.js
        // and the same approach used in snippets/dogheroes--quiz.liquid).
        // The server only needs the resulting daily_calories value to render
        // the new meal plan.
        const dog = buildDogFromEntries(currentEntries())
        const dailyCalories = Math.round(dog.dailyCalories() || 0)

        const requestUrl = new URL(url, window.location.origin)
        requestUrl.searchParams.set('daily_calories', String(dailyCalories))

        try {
          const response = await fetch(requestUrl, {
            method: 'GET',
            headers: { Accept: 'text/html' },
            credentials: 'same-origin',
          })
          if (!response.ok) throw new Error(`Preview request failed: ${response.status}`)
          const html = await response.text()
          if (token !== currentRequestToken) return
          showBody(html)
        } catch (error) {
          if (token !== currentRequestToken) return
          console.error('Failed to load meal plan preview:', error)
          showError()
        }
      })
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--dogs--portions"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'dogheroes--dogs--portions',
    class extends Stimulus.Controller {
      static targets = [
        'card',
        'submit',
        'currentLabel',
        'newLabel',
        'currentGrams',
        'newGrams',
        'deltaGrams',
        'currentPrice',
        'newPrice',
        'deltaPrice',
      ]
      static values = {
        current: String,
        full: Object,
        half: Object,
      }

      connect() {
        this.syncCards()
        this.syncSubmit()
        this.renderDiff()
        this.boundPageshow = this.#stopSubmitting.bind(this)
        window.addEventListener('pageshow', this.boundPageshow)
      }

      disconnect() {
        window.removeEventListener('pageshow', this.boundPageshow)
      }

      select() {
        this.syncCards()
        this.syncSubmit()
        this.renderDiff()
      }

      startSubmitting() {
        this.element.dataset.loading = ''
        if (this.hasSubmitTarget) this.submitTarget.disabled = true
        for (const button of this.element.querySelectorAll('.dogheroes--portal--dialog button')) {
          button.disabled = true
        }
      }

      #stopSubmitting() {
        delete this.element.dataset.loading
        for (const button of this.element.querySelectorAll('.dogheroes--portal--dialog button')) {
          button.disabled = false
        }
        this.syncSubmit()
      }

      get selected() {
        const checked = this.cardTargets
          .map((card) => card.querySelector('input[type="radio"]'))
          .find((input) => input && input.checked)
        return checked ? checked.value : this.currentValue
      }

      syncCards() {
        const selected = this.selected
        for (const card of this.cardTargets) {
          card.classList.toggle('is-selected', card.dataset.portion === selected)
        }
      }

      syncSubmit() {
        if (!this.hasSubmitTarget) return
        this.submitTarget.disabled = this.selected === this.currentValue
      }

      renderDiff() {
        const labels = { full: 'Pasto completo', half: 'Metà porzione' }
        const current = this.currentValue
        const next = this.selected
        const currentData = this[`${current}Value`] || {}
        const nextData = this[`${next}Value`] || {}

        if (this.hasCurrentLabelTarget) this.currentLabelTarget.textContent = labels[current] || '—'
        if (this.hasNewLabelTarget) this.newLabelTarget.textContent = labels[next] || '—'

        const currentGrams = Math.round(currentData.daily_grams ?? 0)
        const nextGrams = Math.round(nextData.daily_grams ?? 0)
        if (this.hasCurrentGramsTarget) this.currentGramsTarget.textContent = `${currentGrams}g`
        if (this.hasNewGramsTarget) this.newGramsTarget.textContent = `${nextGrams}g`
        this.#renderDelta(this.deltaGramsTarget, nextGrams - currentGrams, 'g')

        if (this.hasCurrentPriceTarget) this.currentPriceTarget.textContent = this.#formatPrice(currentData.daily_price)
        if (this.hasNewPriceTarget) this.newPriceTarget.textContent = this.#formatPrice(nextData.daily_price)
        this.#renderDelta(
          this.deltaPriceTarget,
          (nextData.daily_price ?? 0) - (currentData.daily_price ?? 0),
          '',
          this.#formatPrice.bind(this)
        )
      }

      #renderDelta(node, value, suffix = '', formatter = null) {
        if (!node) return
        const rounded = Math.round(value * 100) / 100
        if (rounded === 0) {
          node.textContent = ''
          node.classList.remove('is-positive', 'is-negative')
          return
        }
        const sign = rounded > 0 ? '+' : '−'
        const abs = Math.abs(rounded)
        const formatted = formatter ? formatter(abs) : `${abs}${suffix}`
        node.textContent = `(${sign}${formatted})`
        node.classList.toggle('is-positive', rounded > 0)
        node.classList.toggle('is-negative', rounded < 0)
      }

      #formatPrice(value) {
        const amount = Number(value ?? 0)
        try {
          return new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: 'EUR',
          }).format(amount)
        } catch {
          return `€${amount.toFixed(2)}`
        }
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--portal--cat-photo"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const input = event.target
    if (input.type !== 'file' || !input.closest('.dogheroes--portal--cat-image-dialog')) return

    const dialog = input.closest('.dogheroes--portal--cat-image-dialog')
    const section = dialog.querySelector('.photo-section')
    const preview = dialog.querySelector('.preview')
    if (!preview || !section) return

    const MAX_FILE_SIZE = 5 * 1024 * 1024 // 5MB

    const file = input.files[0]
    if (file && file.size > MAX_FILE_SIZE) {
      alert(dialog.dataset.tooLarge || '')
      input.value = ''
      preview.src = ''
      section.classList.add('hidden')
      return
    }

    if (file) {
      const url = URL.createObjectURL(file)
      preview.src = url
      section.classList.remove('hidden')
      preview.onload = () => URL.revokeObjectURL(url)
    } else {
      preview.src = ''
      section.classList.add('hidden')
    }
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--portal--dialog"] && !Shopify.designMode) return;
  try {
    // Fallback for the Invoker Commands API (`command` / `commandfor`).
  // Browsers without it (Safari iOS < 26.2, Chrome Android < 135, Firefox < 144, in-app
  // WebViews such as WhatsApp's) ignore those attributes, so the buttons that open and close
  // the portal dialogs would do nothing. One delegated listener, installed only when the
  // native API is missing, so modern browsers never get a double toggle.
  if (!('commandForElement' in HTMLButtonElement.prototype) && !window.__dhInvokerFallback) {
    window.__dhInvokerFallback = true

    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || !(event.target instanceof Element)) return

      const button = event.target.closest('button[commandfor][command]')
      if (!button || button.disabled) return

      const target = document.getElementById(button.getAttribute('commandfor'))
      if (!(target instanceof HTMLDialogElement)) return

      switch (button.getAttribute('command')) {
        case 'show-modal':
          if (!target.open) target.showModal()
          break
        case 'close':
        case 'request-close':
          if (target.open) target.close(button.value || undefined)
          break
      }
    })
  }

  // Toggle loading state on the dialog when its associated form is submitted.
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target
      if (!(form instanceof HTMLFormElement) || !form.id) return
      const dialog = document.querySelector(`dialog.dogheroes--portal--dialog[data-form-id="${CSS.escape(form.id)}"]`)
      if (!dialog) return
      dialog.setAttribute('data-loading', '')
      const confirmBtn = dialog.querySelector('[data-dialog-confirm]')
      const cancelBtn = dialog.querySelector('[data-dialog-cancel]')
      if (confirmBtn) confirmBtn.disabled = true
      if (cancelBtn) cancelBtn.disabled = true
    },
    true
  )

  document.addEventListener('click', (event) => {
    const dialog = event.target.closest('dialog.dogheroes--portal--dialog[data-close-on-backdrop]')
    if (!dialog || event.target !== dialog) return
    if (dialog.hasAttribute('data-loading')) return
    const rect = dialog.getBoundingClientRect()
    const inDialog =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom
    if (!inDialog) dialog.close()
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--portal--dog-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const input = event.target
    if (input.type !== 'file' || !input.closest('.dogheroes--portal--dog-card__image-dialog')) return

    const dialog = input.closest('.dogheroes--portal--dog-card__image-dialog')
    const section = dialog.querySelector('.photo-section')
    const preview = dialog.querySelector('.preview')
    if (!preview || !section) return

    const MAX_FILE_SIZE = 5 * 1024 * 1024 // 5MB

    const file = input.files[0]
    if (file && file.size > MAX_FILE_SIZE) {
      alert("L'immagine selezionata supera i 5MB. Scegli un file più piccolo.")
      input.value = ''
      preview.src = ''
      section.classList.add('hidden')
      return
    }

    if (file) {
      const url = URL.createObjectURL(file)
      preview.src = url
      section.classList.remove('hidden')
      preview.onload = () => URL.revokeObjectURL(url)
    } else {
      preview.src = ''
      section.classList.add('hidden')
    }
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--portal--subscription--dialog--cancellation-reason"] && !Shopify.designMode) return;
  try {
    // Nasconde il media se l'immagine del reason non carica (404, URL rotto, ecc.)
  document.addEventListener(
    'error',
    (event) => {
      const img = event.target
      if (!(img instanceof HTMLImageElement)) return
      if (!img.matches('img[data-reason-image]')) return
      const media = img.closest('[data-reason-media]')
      if (media) media.setAttribute('hidden', '')
    },
    true
  )

  document.addEventListener('click', (event) => {
    const dialog = event.target.closest(
      'dialog.dogheroes--portal--subscription--dialog--cancellation-reason[data-close-on-backdrop]'
    )
    if (!dialog || event.target !== dialog) return
    if (dialog.hasAttribute('data-loading')) return
    const rect = dialog.getBoundingClientRect()
    const inDialog =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom
    if (!inDialog) dialog.close()
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--portal--subscription--dialog--pause-success"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const dialog = event.target.closest(
      'dialog.dogheroes--portal--subscription--dialog--pause-success[data-close-on-backdrop]'
    )
    if (!dialog || event.target !== dialog) return
    const rect = dialog.getBoundingClientRect()
    const inDialog =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom
    if (!inDialog) dialog.close()
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--quiz--steps--breed"] && !Shopify.designMode) return;
  try {
    const { Dog } = DogHeroes

  Stimulus.register(
    'breed-step',
    class extends Stimulus.Controller {
      connect() {
        this.element.addEventListener('keydown', (e) => this.handleSummaryKeydown(e), true)
      }

      handleSummaryKeydown(e) {
        // Enter key toggle for accessibility
        if (e.key === 'Enter' && e.target.tagName === 'SUMMARY') {
          e.preventDefault()
          e.stopPropagation()
          e.target.parentElement.toggleAttribute('open')
        }
      }
    }
  )

  Stimulus.register(
    'breed-fieldset',
    class extends Stimulus.Controller {
      connect() {
        this.setupListeners()
      }

      setupListeners() {
        const dogIndexDiv = this.element.querySelector('[data-dog-index]')
        const dogIndex = dogIndexDiv ? parseInt(dogIndexDiv.dataset.dogIndex) : null

        // Exit early if fieldset doesn't have a valid dog index
        if (dogIndex == null) return

        // Syncs to Dog Obj
        const primaryBreedInput = this.element.querySelector('input[name*="[breed]"]:not([name*="additional"])')
        if (primaryBreedInput) {
          primaryBreedInput.addEventListener('change', () => this.updateBreed(dogIndex, primaryBreedInput, 'breed'))
        }

        // Cross breed
        const detailsEl = this.element.querySelector('details')
        if (detailsEl) {
          const secondaryBreedInput = detailsEl.querySelector('input[name*="additional_breed"]')
          if (secondaryBreedInput) {
            secondaryBreedInput.addEventListener('change', () =>
              this.updateBreed(dogIndex, secondaryBreedInput, 'additional_breed')
            )
          }

          detailsEl.addEventListener('toggle', () => this.handleDetailsToggle(dogIndex, detailsEl))
        }
      }

      updateBreed(dogIndex, input, field) {
        const dog = Dog.find(dogIndex)

        if (dog) {
          dog[field] = input.value || null
          dog.save()
          this.updateRecap()
        }
      }

      handleDetailsToggle(dogIndex, detailsEl) {
        // Clear secondary breed on close toggle
        if (!detailsEl.open) {
          const hiddenInput = detailsEl.querySelector('input[name*="additional_breed"]')
          const searchInput = detailsEl.querySelector('[id^="additional-breed-select"]')
          const dog = Dog.find(dogIndex)

          // Reset form and Dog object, persist change and update recap
          if (dog && hiddenInput) {
            hiddenInput.value = ''
            if (searchInput) searchInput.value = ''
            dog.additional_breed = null
            dog.save()
            this.updateRecap()
          }
        }
      }

      closeAdditionalBreed() {
        const detailsEl = this.element.querySelector('details')
        if (detailsEl && detailsEl.open) {
          detailsEl.open = false
        }
      }

      updateRecap() {
        // Update breed slot
        const recapElement = document.querySelector('[data-controller="quiz-recap"]')
        if (recapElement) {
          const recapController = Stimulus.getControllerForElementAndIdentifier(recapElement, 'quiz-recap')
          if (recapController) recapController.render()
        }
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--quiz--steps--health-issues"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'health-issues',
    class extends Stimulus.Controller {
      static targets = ['fieldset', 'checkbox', 'yes']

      connect() {
        this.toggle()
      }

      toggle() {
        if (this.yesTarget.checked) {
          this.fieldsetTarget.style.display = 'flex'
          this.checkboxTargets.forEach((checkbox) => {
            checkbox.dataset.required = 'true'
          })
        } else {
          this.fieldsetTarget.style.display = 'none'
          this.checkboxTargets.forEach((checkbox) => {
            checkbox.checked = false
            checkbox.removeAttribute('data-required')
          })
        }
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--quiz--steps--weight"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'weight-validation',
    class extends Stimulus.Controller {
      static targets = ['weight', 'alert']
      static values = { maxWeight: 200, alertThreshold: 100 }

      // Focus the input when clicking anywhere in the wrapper (the "kg" suffix or the padding)
      focusInput(event) {
        if (event.target !== this.weightTarget) {
          this.weightTarget.focus()
        }
      }

      validateWeight() {
        const input = this.weightTarget

        // Limit to at most 2 decimal places without rounding (truncate extra digits)
        const dotIndex = input.value.indexOf('.')
        if (dotIndex !== -1 && input.value.length - dotIndex - 1 > 2) {
          input.value = input.value.slice(0, dotIndex + 3)
        }

        const weight = parseFloat(input.value)

        // Nothing entered yet (or an in-progress value like "12."): leave it alone
        if (Number.isNaN(weight)) {
          this.alertTarget.style.display = 'none'
          return
        }

        // Cap weight at max limit and show alert banner if exceeded
        if (weight > this.maxWeightValue) {
          input.value = this.maxWeightValue
          this.alertTarget.style.display = 'block'
        } else if (weight > this.alertThresholdValue) {
          this.alertTarget.style.display = 'block'
        } else {
          this.alertTarget.style.display = 'none'
        }
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--quiz-banner"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'dogheroes--quiz-banner',
    class extends Stimulus.Controller {
      dismiss(event) {
        const alertElement = event.target.closest('.alert')
        if (alertElement) {
          alertElement.style.display = 'none'
        }
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--quiz-recap"] && !Shopify.designMode) return;
  try {
    let { render, tag, Dog } = DogHeroes

  Stimulus.register(
    'quiz-recap',
    class extends Stimulus.Controller {
      static targets = ['dogsContainer', 'title']

      static values = {
        sexes: { male: 'Maschietto', female: 'Femminuccia' },
      }

      connect() {
        this.algorithmData = DogHeroes.algorithmData
        this.stepMap = {
          breed: 1,
          gender: 2,
          age: 3,
          weight: 4,
          diet: 7,
          allergies: 8,
          diseases: 9,
        }
        this.render()
        const handleButtonAction = (e) => {
          let button = e.target.closest('.quiz-recap-button')
          if (button) {
            // Check list item buttons first
            let step = button.closest('[data-quiz-step]')?.dataset.quizStep
            // Fallback to description button data attribute
            if (!step) step = button.dataset.descriptionStep
            if (step) this.navigateToStep(step)
          }
        }
        this.element.addEventListener('click', handleButtonAction)
        this.element.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            let button = e.target.closest('.quiz-recap-button')
            if (button) {
              e.preventDefault()
              handleButtonAction(e)
            }
          }
        })
      }

      shouldRender(dog) {
        if (!dog) return false
        if (dog.breed || dog.sex || dog.weight) return true
        return false
      }

      render() {
        const dogs = Dog.all().filter((dog) => this.shouldRender(dog))
        requestAnimationFrame(() => {
          this.element.innerHTML = ''
          dogs.forEach((dog) => {
            let dogElement = this.renderDog(dog)
            this.element.appendChild(dogElement)
          })
          this.element.toggleAttribute('hidden', dogs.length === 0)
        })
      }

      renderDog(dog) {
        let { allergies, breed, additional_breed, build, diet, diseases, sex, sterilization, weight } = dog.attributes()

        let getBreed = (breed) => {
          return this.algorithmData.dog_breeds.find((b) => b.handle === breed)?.name || breed
        }

        let createDescriptionElement = (content, step) => {
          let p = document.createElement('p')
          let button = document.createElement('button')
          button.type = 'button'
          button.className = 'quiz-recap-button'
          button.innerHTML = content
          button.setAttribute('data-description-step', step)
          p.appendChild(button)
          return p
        }

        let descriptions = []
        if (weight && build) {
          let weightDescription = `Pesa <strong>${weight}kg</strong>`
          let weightLabel = this.algorithmData.body_condition_factor.find((b) => b.handle === build)?.label
          let bodyCondition = ` e la sua corporatura è ${weightLabel}`
          descriptions.push([weightDescription + bodyCondition, 'weight'])
        }
        if (sterilization) {
          let suffix = sex === 'female' ? 'a' : 'o'
          let sterilizationLabel = sterilization === 'yes' ? `Sterilizzat${suffix}` : `Non sterilizzat${suffix}`
          descriptions.push([sterilizationLabel, 'gender'])
        }
        if (diet)
          descriptions.push([`Dieta attuale: <strong>${diet?.join(', ') || 'non specificata'}</strong>`, 'diet'])
        if (allergies)
          descriptions.push([`Allergie: <strong>${allergies?.join(', ') || 'nessuna'}</strong>`, 'allergies'])
        if (diseases)
          descriptions.push([`Problemi di salute: <strong>${diseases?.join(', ') || 'nessuno'}</strong>`, 'diseases'])

        let element = render('dh-quiz-recap-dog', {
          name: dog.displayName,
          breed: [getBreed(additional_breed), getBreed(breed)].filter(Boolean).join(' X '),
          male: sex === 'male' ? this.sexesValue[sex] : '',
          female: sex === 'female' ? this.sexesValue[sex] : '',
          age: dog.age?.toString(),
          description: descriptions.filter(Boolean).map(([desc, step]) => createDescriptionElement(desc, step)),
        })

        // Remove empty list items
        element.querySelectorAll('li').forEach((el) => el.textContent.trim() === '' && el.remove())

        return element
      }

      navigateToStep(stepName) {
        let stepIndex = this.stepMap[stepName]
        if (stepIndex === undefined) return

        let quizElement = document.querySelector('[data-controller="quiz"]')
        if (!quizElement) return

        let quizController =
          quizElement.stimulusController || Stimulus.getControllerForElementAndIdentifier(quizElement, 'quiz')
        if (quizController) quizController.setCurrentStep(stepIndex)
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--quiz"] && !Shopify.designMode) return;
  try {
    const { Dog, serializeDog } = DogHeroes

  Stimulus.register(
    'quiz',
    class extends Stimulus.Controller {
      static targets = ['step', 'prevButton', 'nextButton', 'loaderModal']

      static values = {
        currentStep: { type: Number, default: 0 }, // zero-based index
        stepKey: { type: String, default: 'dogheroes.quiz' },
        quizStartedAtKey: { type: String, default: 'dogheroes.quiz_started_at' },
        customerFirstName: { type: String, default: '' },
        customerLastName: { type: String, default: '' },
        customerEmail: { type: String, default: '' },
        customerId: { type: String, default: '' },
        customerDogHandles: { type: Array, default: [] },
      }

      connect() {
        if (this.handleBridge()) return

        this.cleanupKnownDogs()
        this.renderDogs()
        this.restoreSavedData()
        const bridgeCustomer = this.restoreSavedCustomerData()
        this.setCurrentStep(localStorage.getItem(this.stepKeyValue))
        this.hideLoaderModal()
        this.initQuizStartedAt()
        this.pushQuizOpenDataLayerEvent()
        window.addEventListener('pageshow', this.handlePageShow.bind(this))

        // Must run after setCurrentStep() above (needs the real
        // currentStepValue/isLastStep) and after restoreSavedCustomerData()
        // has already applied bridgeCustomer to the step 10 inputs.
        this.maybeAutoSubmitFromBridge(bridgeCustomer)
      }

      disconnect() {
        window.removeEventListener('pageshow', this.handlePageShow.bind(this))
      }

      // --- URL bridge (external prefill, e.g. the Dog Heroes Link Hub) ---
      //
      // Lets another first-party page deep-link into the quiz with the dog's
      // data already known. Approved by Nebulab (04/2026): writing to
      // localStorage and reloading is equivalent to a user resuming a
      // partially completed quiz, so this reuses that exact mechanism (Dog
      // model + stepKey) instead of a new code path. With no `bridge` param
      // the quiz is 100% unaffected.
      //
      // Contract (query params on /pages/quiz):
      //   bridge=1 (required to activate)
      //   name (required; a blank/missing name leaves the quiz untouched)
      //   breed, additional_breed? (not supported by the bridge), sex,
      //   birthday, weight, build, activity, sterilization, hunger,
      //   diet=handle1,handle2, allergies=handle1,handle2,
      //   has_diseases=yes|no, diseases=handle1,handle2
      //   utm_* params are preserved on the redirect to /pages/quiz
      //
      // Optional customer-data prefill (URL FRAGMENT, never the query
      // string, so it's never sent to the server — no server logs, no
      // GA4/GTM page_location, no Referer header):
      //   #c_name=...&c_email=...&c_phone=...&c_zip=...&c_consent=1
      // (URLSearchParams-encoded). Each value is lightly validated by
      // bridgeCustomerDataFromFragment() below and, if valid, saved to a
      // DEDICATED, ONE-SHOT localStorage key (`dogheroes.bridge_customer`,
      // JSON) — deliberately NOT the `dogheroes.customer_name/_email/
      // _phone/_zip` keys saveCurrentStep() writes for every visitor who
      // reaches step 10. Those keys persist across quiz runs (read back by
      // the post-quiz checkout prefill), so reading them here would leak a
      // PREVIOUS visitor's contact data into step 10 for anyone who redoes
      // the quiz on a shared device, even with no bridge involved at all —
      // zero impact on a normal (non-bridge) visit is a hard requirement.
      // restoreSavedCustomerData() reads ONLY `dogheroes.bridge_customer`,
      // applies it once to the step 10
      // (dogheroes--quiz--steps--customer-data.liquid) fields, and removes
      // the key right away (one-shot — see that method for why that's safe
      // against back/forward navigation between steps). A visitor who
      // arrives with valid contact data only has to press "Salva e
      // prosegui" there. Invalid/missing values are simply dropped (step
      // 10 stays blank for that field, exactly like today).
      //
      // `c_consent=1` (decision: Marco, 10/2026) means the hub already
      // collected marketing consent from the user with the EXACT SAME text
      // and links as the `quiz[consent_marketing]` checkbox below (a
      // required, non-prechecked checkbox there too) — so it is safe to
      // treat it as equivalent to checking that box on the site. Any other
      // value (missing, `0`, anything but the literal `1`) means no
      // consent was given and is never assumed. This is the ONLY bridge
      // field that result in ticking a checkbox on the user's behalf —
      // see maybeAutoSubmitFromBridge() below for the single, narrow case
      // (full customer data + explicit consent + dog data already
      // complete + not logged in) where that additionally skips the
      // "Salva e prosegui" click and submits the quiz straight to
      // /pages/recipes. Outside that one case the checkbox is left
      // unchecked exactly like today, even when `c_consent=1` was given:
      // the consent value is only ever consumed together with a full
      // auto-submit, never applied on its own while leaving the form for
      // the user to finish manually.
      //
      // Every value other than `name` is validated against the options the
      // quiz itself currently renders (most are metaobject-backed and can
      // change over time); anything unrecognised is dropped (set to null /
      // left out of the list) rather than saved as-is. `build` only accepts
      // non-deprecated dog_body_condition_factor handles (currently
      // `robusta`/`ideale`/`magra`), matching the `reject: 'deprecated'`
      // the weight step itself applies.
      //
      // Decision (Alessandro, 10/2026): missing/discarded data is NOT
      // defaulted or assumed — it blocks exactly like it would for someone
      // filling the quiz in on the site. On the site EVERY step is shown to
      // and confirmed by the user, even the ones that ship with a default
      // (the build/activity sliders start on a value, "Nessuna" is
      // pre-checked on the allergies step, has_diseases defaults to "no")
      // — a real visitor always sees and (implicitly, by pressing
      // "Prosegui") confirms that default. The bridge must not apply any
      // of those defaults silently on someone's behalf: every field the
      // site shows must be explicit and valid in the URL, or the bridge
      // stops there so the user actually sees and confirms it. So instead
      // of always landing on step 10 ("customer data"), the bridge lands
      // on the FIRST step (0-9) whose data is missing or was discarded as
      // invalid, using the quiz's own field-by-field rules (see
      // bridgeFirstIncompleteStep() below for exactly which rule comes from
      // which file/line). Only when every step 0-9 is already explicitly
      // answered does it go straight to step 10. Any already-known data
      // (earlier or later steps) stays prefilled via the normal
      // restoreSavedData() path, so continuing from the landing step
      // behaves exactly like resuming a partially completed quiz.
      handleBridge() {
        const params = new URLSearchParams(window.location.search)
        if (!params.has('bridge')) return false

        const name = (params.get('name') || '').trim()
        if (!name) return false

        this.bridgeCustomerDataFromFragment()

        const pick = (raw, allowed) => {
          if (!raw) return null
          const value = raw.trim()
          return allowed.has(value) ? value : null
        }
        const pickList = (raw, allowed) =>
          (raw || '')
            .split(',')
            .map((value) => value.trim())
            .filter((value) => value && allowed.has(value))

        const dietValues = this.bridgeAllowedValues(7, 'diet')
        const allergyValues = this.bridgeAllowedValues(8, 'allergies')
        const diseaseValues = this.bridgeAllowedValues(9, 'diseases')
        const hungerValues = this.bridgeAllowedValues(6, 'hunger')
        // Read straight from each step's own <range-slider data-object="...">
        // (already rendered server-side from the filtered Liquid collection,
        // see bridgeSliderHandles() below) instead of
        // window.DogHeroes.algorithmData, which mirrors the metaobjects
        // directly and is NOT guaranteed to have the same
        // `| reject: 'deprecated'` filter the weight step applies to
        // `body_condition_factor` (dogheroes--quiz--steps--weight.liquid).
        const buildValues = this.bridgeSliderHandles(4, 'build')
        const activityValues = this.bridgeSliderHandles(5, 'activity')

        const diseases = pickList(params.get('diseases'), diseaseValues)
        // No longer inferred from `diseases`: has_diseases must be given
        // explicitly, exactly like every other field (see decision above).
        const hasDiseases = pick(params.get('has_diseases'), this.bridgeAllowedValues(9, 'has_diseases'))
        const birthday = this.bridgeNormalizeBirthday(params.get('birthday'))

        const dog = new Dog({
          index: 0,
          name,
          breed: pick(params.get('breed'), this.bridgeAlgorithmHandles('dog_breeds')),
          additional_breed: null,
          sex: pick(params.get('sex'), this.bridgeAllowedValues(2, 'sex')),
          birthday,
          birthday_type: birthday ? 'approximate' : null,
          weight: this.bridgeNormalizeWeight(params.get('weight')),
          build: pick(params.get('build'), buildValues),
          activity: pick(params.get('activity'), activityValues),
          sterilization: pick(params.get('sterilization'), this.bridgeAllowedValues(2, 'sterilization')),
          hunger: pick(params.get('hunger'), hungerValues),
          diet: pickList(params.get('diet'), dietValues),
          allergies: pickList(params.get('allergies'), allergyValues),
          has_diseases: hasDiseases,
          diseases,
          daily_calories: null,
        })

        // Replace any leftover/abandoned quiz session with just this dog.
        Dog.destroyAll()
        dog.save()
        localStorage.setItem(this.stepKeyValue, String(this.bridgeFirstIncompleteStep(dog)))

        const utm = new URLSearchParams()
        params.forEach((value, key) => {
          if (key.toLowerCase().startsWith('utm_')) utm.set(key, value)
        })
        const query = utm.toString()
        window.location.replace(query ? `/pages/quiz?${query}` : '/pages/quiz')

        return true
      }

      // Reads optional customer-data prefill from the URL fragment (see the
      // contract comment above handleBridge()) and, for each value that
      // passes a light validation, stashes it in a DEDICATED, ONE-SHOT
      // localStorage key (`dogheroes.bridge_customer`, JSON) — NOT the
      // `dogheroes.customer_name/_email/_phone/_zip` keys saveCurrentStep()
      // writes for every visitor. Those persist across quiz runs (the
      // post-quiz checkout prefill reads them back), so writing to them
      // here would leak this bridge visit's contact data into a LATER,
      // unrelated quiz run on the same device/browser — the bridge must
      // have zero effect on anyone who didn't arrive through it. See
      // restoreSavedCustomerData() for how the one-shot key is consumed.
      // Writes nothing at all if every value is missing/invalid (no empty
      // key left behind). Does NOT touch the consent/marketing checkbox
      // itself here — `consent` is only ever stashed alongside the other
      // fields for maybeAutoSubmitFromBridge() (called from connect(),
      // after restoreSavedCustomerData() applies the rest of this data to
      // step 10) to decide, never applied directly by this method.
      bridgeCustomerDataFromFragment() {
        const hash = window.location.hash
        if (!hash || hash.length < 2) return

        const fragment = new URLSearchParams(hash.slice(1))

        const name = (fragment.get('c_name') || '').trim()
        const email = (fragment.get('c_email') || '').trim()
        const phone = (fragment.get('c_phone') || '').trim()
        const zip = (fragment.get('c_zip') || '').trim()
        // Only the literal "1" counts as consent given — anything else
        // (missing, "0", garbage) is treated as no consent, never assumed.
        const consent = fragment.get('c_consent') === '1' ? true : null

        // Light, plausibility-only validation — the site's own step 10
        // inputs (type="email", 5-digit CAP, digits-only phone) are the
        // real gate the user still goes through.
        const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
        const isValidPhone = (value) => /^[0-9+\s]+$/.test(value) && value.replace(/[^0-9]/g, '').length >= 6
        const isValidZip = (value) => /^\d{5}$/.test(value)

        const values = {
          customer_name: name || null,
          customer_email: isValidEmail(email) ? email : null,
          customer_phone: isValidPhone(phone) ? phone : null,
          customer_zip: isValidZip(zip) ? zip : null,
          consent: consent,
        }

        const validValues = Object.fromEntries(Object.entries(values).filter(([, value]) => value != null))

        if (Object.keys(validValues).length > 0) {
          localStorage.setItem('dogheroes.bridge_customer', JSON.stringify(validValues))
        }
      }

      // Reads the allowed values for a field straight from the quiz's own
      // step template (not yet cloned/visible), so the bridge always
      // matches whatever the metaobject-backed options currently are
      // instead of a hardcoded, driftable list.
      bridgeAllowedValues(stepIndex, fieldName) {
        const step = this.element.querySelector(`[data-quiz-target="step"][data-step="${stepIndex}"]`)
        const template = step && step.querySelector('template[data-fieldset-template]')
        if (!template) return new Set()

        const inputs = template.content.querySelectorAll(
          `input[name$="[${fieldName}]"], input[name$="[${fieldName}][]"]`
        )
        return new Set(Array.from(inputs, (input) => input.value).filter(Boolean))
      }

      // Finds the first step (0-9) whose data is missing or was discarded
      // as invalid, so the bridge can land the user there instead of
      // always jumping to step 10. Per the decision above, this is
      // intentionally stricter than the quiz's own isCurrentStepValid()
      // (which only reads `[data-required]`): every field the site SHOWS
      // the user — including build/activity (sliders with a default
      // value) and has_diseases (radio defaulting to "no") — must be
      // explicit and valid here too, so nothing gets silently confirmed on
      // the user's behalf. Each check cites the exact file/rule it starts
      // from. Returns 10 when every step is already explicitly answered.
      bridgeFirstIncompleteStep(dog) {
        const checks = [
          // Step 0 — dogheroes--quiz--steps--name.liquid: the name input
          // carries data-required.
          () => Boolean(dog.name && dog.name.trim() !== ''),
          // Step 1 — dogheroes--quiz--steps--breed.liquid renders
          // dogheroes--ui--select-breed.liquid with required: true.
          () => Boolean(dog.breed),
          // Step 2 — dogheroes--quiz--steps--sex.liquid: both the sex and
          // sterilization dogheroes--ui--radio-row.liquid fields are
          // rendered with required: true.
          () => Boolean(dog.sex) && Boolean(dog.sterilization),
          // Step 3 — dogheroes--quiz--steps--age.liquid passes
          // `data-required` to BOTH hidden inputs of
          // dogheroes--ui--age-input.liquid (birthday and birthday_type).
          () => Boolean(dog.birthday) && Boolean(dog.birthday_type),
          // Step 4 — dogheroes--quiz--steps--weight.liquid: the weight
          // <input> carries data-required. The body-condition (`build`)
          // dogheroes--ui--slider-input.liquid has none — on the site its
          // `range-slider` custom element silently self-selects a default
          // handle on connect — but a real visitor still SEES and
          // implicitly confirms that default by pressing "Prosegui" on
          // this step, so the bridge requires `build` explicitly too
          // instead of applying that default unseen.
          () =>
            dog.weight != null && String(dog.weight).trim() !== '' && parseFloat(dog.weight) > 0 && Boolean(dog.build),
          // Step 5 — dogheroes--quiz--steps--activity.liquid: same slider
          // component and same reasoning as `build` above — required
          // explicitly even though the site itself would auto-default it.
          () => Boolean(dog.activity),
          // Step 6 — dogheroes--quiz--steps--hungry.liquid renders
          // dogheroes--ui--radio-image-cards.liquid with required: true and
          // no default `selected` -> a real user must pick one.
          () => Boolean(dog.hunger),
          // Step 7 — dogheroes--quiz--steps--diet.liquid: every checkbox
          // carries data-required and none starts checked -> at least one
          // diet category must be selected.
          () => Array.isArray(dog.diet) && dog.diet.length > 0,
          // Step 8 — dogheroes--quiz--steps--allergies.liquid renders
          // dogheroes--ui--allergy-checkboxes.liquid: only the "Nessuna"
          // checkbox carries data-required, and on the site it ships
          // pre-checked when the field is unanswered. A real visitor still
          // sees and confirms that default (or picks specific allergies)
          // before pressing "Prosegui", so the bridge requires at least one
          // explicit, valid selection here too — "Nessuna" included —
          // instead of assuming it unseen.
          () => Array.isArray(dog.allergies) && dog.allergies.length > 0,
          // Step 9 — dogheroes--quiz--steps--health-issues.liquid: the
          // has_diseases radios have no data-required and default to "no"
          // on the site, confirmed the same way as the sliders above. The
          // `health-issues` Stimulus controller's toggle() additionally
          // requires at least one checked disease checkbox once
          // has_diseases is "yes". So the bridge requires has_diseases
          // explicitly (`yes` or `no`, never inferred from `diseases`) and,
          // when it's "yes", at least one valid disease.
          () =>
            dog.has_diseases != null &&
            (dog.has_diseases !== 'yes' || (Array.isArray(dog.diseases) && dog.diseases.length > 0)),
        ]

        for (let step = 0; step < checks.length; step++) {
          if (!checks[step]()) return step
        }
        return 10
      }

      // Same idea for fields driven by window.DogHeroes.algorithmData
      // (currently just breed) rather than by plain form inputs.
      bridgeAlgorithmHandles(key) {
        const list = (window.DogHeroes && window.DogHeroes.algorithmData && window.DogHeroes.algorithmData[key]) || []
        return new Set(list.map((item) => item.handle).filter(Boolean))
      }

      // Reads the handles a range-slider (build/activity, rendered by
      // dogheroes--ui--slider-input.liquid) actually offers, straight from
      // its `data-object` JSON in the quiz's own step template. Unlike
      // bridgeAlgorithmHandles()/window.DogHeroes.algorithmData (a flat
      // metaobject dump with no filtering), this reflects whatever
      // server-side Liquid filtering that step applies before rendering —
      // e.g. dogheroes--quiz--steps--weight.liquid runs
      // `metaobjects.body_condition_factor.values | reject: 'deprecated'`
      // before handing the list to the slider, so a deprecated `build`
      // handle (like the old "molto-magra"/"sovrappeso") is correctly
      // rejected here too.
      bridgeSliderHandles(stepIndex, fieldName) {
        const step = this.element.querySelector(`[data-quiz-target="step"][data-step="${stepIndex}"]`)
        const template = step && step.querySelector('template[data-fieldset-template]')
        const input = template && template.content.querySelector(`input[name$="[${fieldName}]"]`)
        const rangeSlider = input && input.closest('range-slider')
        if (!rangeSlider) return new Set()

        let items = []
        try {
          items = JSON.parse(rangeSlider.dataset.object || '{}').items || []
        } catch (e) {
          items = []
        }
        return new Set(items.map((item) => item.handle).filter(Boolean))
      }

      // Accepts "YYYY-MM-DD", "YYYY-MM", "YYYYMMDD" or "YYYYMM" and returns
      // the "YYYYMM" format Dog/Age expect for an approximate birthday (the
      // bridge never claims to know the exact day).
      bridgeNormalizeBirthday(raw) {
        if (!raw) return null
        const match = String(raw)
          .trim()
          .match(/^(\d{4})-?(\d{2})(?:-?\d{2})?$/)
        if (!match) return null

        const year = parseInt(match[1], 10)
        const month = parseInt(match[2], 10)
        const currentYear = new Date().getFullYear()
        if (year < 1990 || year > currentYear || month < 1 || month > 12) return null

        return `${match[1]}${match[2]}`
      }

      bridgeNormalizeWeight(raw) {
        if (!raw) return null
        const value = parseFloat(String(raw).replace(',', '.'))
        if (!Number.isFinite(value) || value <= 0 || value > 200) return null
        return String(value)
      }

      initQuizStartedAt() {
        if (!localStorage.getItem(this.quizStartedAtKeyValue)) {
          localStorage.setItem(this.quizStartedAtKeyValue, new Date().toISOString())
        }
      }

      handlePageShow(event) {
        if (
          event.persisted ||
          performance.getEntriesByType('navigation').some((entry) => entry.type === 'back_forward')
        ) {
          this.hideLoaderModal()
        }
      }

      hideLoaderModal() {
        if (!this.hasLoaderModalTarget) return

        this.loaderModalTarget.hidden = true
        this.loaderModalTarget.classList.remove('dogheroes--quiz-loader-modal--visible')
      }

      // If a dog from localStorage matches any of the customer's dogs
      // it means the quiz was completed and we can drop that dog.
      cleanupKnownDogs() {
        console.log('Cleaning up known dogs...', this.customerDogHandlesValue)
        let needsReload = false
        Dog.all().forEach((dog) => {
          console.log('Checking dog:', dog.handle)
          if (this.customerDogHandlesValue.includes(dog.handle)) {
            dog.destroy()
            this.setCurrentStep(0)
            needsReload = true
          }
        })
        // Reloading the page is necessary to reset the quiz state and start fresh for the user.
        if (needsReload) location.reload()
      }

      get currentStepElement() {
        return this.stepTargets[this.currentStepValue]
      }

      get isLastStep() {
        return this.currentStepValue === this.stepTargets.length - 1
      }

      get isFirstStep() {
        return this.currentStepValue === 0
      }

      // Link the anonymous browser session (Klaviyo __kla_id cookie) to the
      // lead's email so onsite flows (Viewed Product, Active on Site, etc.)
      // can attribute events to the right profile. Runs after every completed
      // step so identification starts as soon as the email is left, not only
      // at quiz completion — abandoned quizzes must still get onsite
      // attribution. The actual subscription — consent, list, profile
      // attributes — is created server-side by UpsertCustomerToKlaviyoJob
      // from the quiz POST handler.
      notifyKlaviyo() {
        const email = this.element.elements['quiz[customer_email]'].value
        if (!email || email === this.lastIdentifiedEmail) return

        if (typeof klaviyo === 'undefined') {
          console.warn('Klaviyo is not defined. Skipping Klaviyo notification.')
          return
        }

        this.lastIdentifiedEmail = email
        klaviyo.identify({ email: email })
      }

      async next(event) {
        //console.log('next() called', { eventType: event.type, eventTarget: event.target, currentStep: this.currentStepValue })

        // Block Enter on previous button — let previous() handle it instead
        if (
          event.type === 'keydown' &&
          event.key === 'Enter' &&
          this.hasPrevButtonTarget &&
          event.target === this.prevButtonTarget
        ) {
          return
        }

        // Only respond to real user events: form submit, trusted keyboard, or pointer clicks.
        // Synthetic events (browser autofill, password managers) are not trusted and must
        // never advance the quiz, even though they can mimic an Enter keydown on an input.
        if (event instanceof KeyboardEvent && !event.isTrusted) return
        if (event instanceof KeyboardEvent && event.key !== 'Enter') return

        // Enter must only advance when the current step is valid. We read validity live
        // via isCurrentStepValid() rather than the next button's `disabled` property, which
        // can be stale when fields are pre-filled (breed/age restore asynchronously and may
        // not have re-synced the button yet). The breed/age custom dropdowns stop Enter from
        // bubbling here while open, so this never fires mid-selection.
        if (event.type === 'keydown' && !this.isCurrentStepValid()) {
          event.preventDefault()
          return
        }

        event.preventDefault()

        // Prevent autofill-triggered form submissions on all steps.
        // When autofill auto-submits the form, event.type is 'submit' (not 'click').
        if (event.type === 'submit') {
          event.preventDefault()
          return
        }

        if (this.isLastStep) {
          if (!this.isCurrentStepValid()) return

          await this.submitQuiz()
          return
        }

        if (!this.isCurrentStepValid()) return

        await this.saveCurrentStep()
        this.notifyKlaviyo()
        this.pushStepCompletedDataLayerEvent(this.currentStepValue)
        this.setCurrentStep(this.currentStepValue + 1)
        this.dispatch('nextStep', {
          detail: { currentStep: this.currentStepValue },
        })
      }

      // Extracted from next()'s last-step branch so maybeAutoSubmitFromBridge()
      // (bridge auto-submit, see that method) can trigger the exact same
      // submission a manual "Salva e prosegui" click does — same events,
      // same hidden fields, same form.submit(). Behaviour for the manual
      // click is unchanged: next() still calls this at the same point,
      // after its own isCurrentStepValid() check.
      async submitQuiz() {
        await this.saveCurrentStep()
        this.pushQuizCompletedDataLayerEvent()
        this.pushKlaviyoLeadDataLayerEvents()
        this.notifyKlaviyo()
        this.showLoaderModal()

        let appendHiddenInput = (name, value) => {
          let input = document.createElement('input')
          input.type = 'hidden'
          input.name = name
          input.value = value
          this.element.appendChild(input)
        }

        // Add an hidden field with the calories count for each dog to be processed in the backend
        const dogs = Dog.all()

        dogs.forEach((dog, index) => {
          appendHiddenInput(`quiz[${index}][handle]`, dog.handle)
          appendHiddenInput(`quiz[${index}][daily_calories]`, dog.daily_calories || 0)
        })

        // Forward the quiz_started_at timestamp from localStorage so the
        // server-side Klaviyo subscribe job can record quiz_first_seen.
        appendHiddenInput('quiz[quiz_started_at]', localStorage.getItem(this.quizStartedAtKeyValue) || '')

        this.element.submit()
      }

      pushQuizOpenDataLayerEvent() {
        const payload = {
          event: 'quiz_open',
          quiz_type: 'dog',
        }

        this.pushToDataLayer(payload)
      }

      pushStepCompletedDataLayerEvent(submittedStepIndex) {
        const payload = {
          event: 'quiz_step_completed',
          step_number: submittedStepIndex + 1,
          quiz_type: 'dog',
          dogs: this.collectDogsForStep(submittedStepIndex),
        }

        this.pushToDataLayer(payload)
      }

      pushQuizCompletedDataLayerEvent() {
        this.pushToDataLayer({
          event: 'quiz_completed',
          ...this.leadFields(),
          dogs: this.serializedDogs(),
        })
      }

      // A per-dog companion to quiz_completed (GTM routes this one to Klaviyo as
      // a lead): same lead fields, one event per dog.
      pushKlaviyoLeadDataLayerEvents() {
        this.serializedDogs().forEach((dog) => {
          this.pushToDataLayer({
            event: 'klaviyo_lead',
            ...this.leadFields(),
            dogs: [dog],
          })
        })
      }

      // Serialize the saved dogs with the SAME helper the post-quiz events use
      // (food_type_selected etc.), so the dog schema is identical, field for field.
      serializedDogs() {
        return Dog.all().map((dog) => serializeDog(dog))
      }

      leadFields() {
        return {
          quiz_type: 'dog',
          user_name: this.getFormFieldValue('quiz[customer_name]'),
          user_email: this.getFormFieldValue('quiz[customer_email]'),
          user_phone: this.getFormFieldValue('quiz[customer_phone]'),
          user_zip_code: this.getFormFieldValue('quiz[customer_zip]'),
        }
      }

      buildUserData() {
        return {
          first_name: this.customerFirstNameValue || null,
          last_name: this.customerLastNameValue || null,
          email: this.customerEmailValue || null,
          customer_id: this.customerIdValue || null,
          shopify_client_id: this.shopifyClientId(),
        }
      }

      pushToDataLayer(payload) {
        window.dataLayer = window.dataLayer || []
        const fullPayload = {
          ...payload,
          user_data: this.buildUserData(),
        }
        if (typeof window.dataLayer === 'undefined') {
          console.warn('dataLayer is not defined. Cannot push event:', fullPayload)
          return
        }
        console.log('Pushing to dataLayer:', fullPayload)
        window.dataLayer.push(fullPayload)
      }

      getFormFieldValue(name) {
        const value = this.element.elements[name]?.value
        if (typeof value !== 'string') return value || null

        const trimmedValue = value.trim()
        return trimmedValue === '' ? null : trimmedValue
      }

      collectDogsForStep(submittedStepIndex) {
        const dogs = []
        const elements = Array.from(this.element.elements).filter((element) => {
          if (!element.name) return false
          const stepElement = element.closest("[data-quiz-target='step']")
          if (!stepElement) return false

          const inputStep = parseInt(stepElement.dataset.step, 10)
          return !isNaN(inputStep) && inputStep <= submittedStepIndex
        })

        elements.forEach((input) => {
          const index = this.getInputIndex(input)
          const key = this.getInputKey(input)

          if (index == null || key == null) return

          if (!dogs[index]) dogs[index] = { index: index }

          const serializedEntry = this.serializeDogField(input, key)
          if (!serializedEntry) return

          const [fieldName, fieldValue] = serializedEntry
          dogs[index][fieldName] = fieldValue
        })

        return dogs.filter(Boolean)
      }

      serializeDogField(input, key) {
        let value = null

        if (input.type === 'radio') {
          if (!input.checked) return null
          value = input.value
        } else if (input.type === 'checkbox' && input.hasAttribute('data-checkbox-multiple')) {
          const index = this.getInputIndex(input)
          const allCheckboxes = input.form.querySelectorAll(
            `input[type="checkbox"][data-checkbox-multiple][name="quiz[${index}][${key}]"]`
          )
          value = Array.from(allCheckboxes)
            .filter((checkbox) => checkbox.checked)
            .map((checkbox) => checkbox.value)

          if (value.length === 0) return null
        } else if (input.type === 'checkbox') {
          value = input.checked ? 'yes' : 'no'
        } else {
          value = typeof input.value === 'string' ? input.value.trim() : input.value
          if (value == null || value === '') return null
        }

        return [key, value]
      }

      shopifyClientId() {
        const match = document.cookie.match(/(?:^|; )shopify_client_id=([^;]+)/)
        return match ? decodeURIComponent(match[1]) : null
      }

      setCurrentStep(step) {
        if (!step) step = 0
        if (isNaN(step)) step = 0
        if (step < 0 || step >= this.stepTargets.length) step = 0

        this.currentStepValue = step
        localStorage.setItem(this.stepKeyValue, this.currentStepValue)
        this.renderCurrentStep()
      }

      async previous(event) {
        //console.log('previous() called', { eventType: event.type, eventTarget: event.target, currentStep: this.currentStepValue })
        if (this.isFirstStep) return

        // Block any keydown events on inputs from going back.
        // Autofill can trigger keydown events that match the form's listeners.
        if (event.type === 'keydown' && event.target instanceof HTMLInputElement) {
          console.log('Blocking keydown on input')
          event.preventDefault()
          return
        }

        // Only respond to real user events: trusted keyboard or pointer clicks
        if (event instanceof KeyboardEvent && !event.isTrusted) return
        if (event instanceof KeyboardEvent) {
          // Escape goes back a step (from anywhere in the step). Enter goes back only when
          // the back button itself is focused, so it doesn't fight with next().
          const isPrevButtonFocused = event.target === this.prevButtonTarget
          const isEscape = event.key === 'Escape'
          const isEnterOnButton = event.key === 'Enter' && isPrevButtonFocused
          if (!isEscape && !isEnterOnButton) return
        }

        event.preventDefault()

        await this.saveCurrentStep()
        this.setCurrentStep(this.currentStepValue - 1)
        this.dispatch('previousStep', {
          detail: { currentStep: this.currentStepValue },
        })
      }

      renderCurrentStep() {
        this.stepTargets.forEach((step, index) => {
          step.classList.toggle('active', index === this.currentStepValue)
        })

        this.updateDogNamePlaceholders()
        this.updateProgressStepper()
        this.renderButtons()

        this.scrollToTop()
        this.focusCurrentStep()
      }

      // Move focus into the active step so the form-scoped `keydown.enter` shortcut works
      // even on pre-filled steps where the user hasn't focused any field yet. Without this,
      // focus stays on <body> (outside the form), the Enter keydown never bubbles to the
      // form, and pressing Enter does nothing until the user interacts with a field.
      // The container is focused (not a field) so the breed/age dropdowns don't auto-open.
      focusCurrentStep() {
        const step = this.currentStepElement
        if (!step) return
        if (!step.hasAttribute('tabindex')) step.setAttribute('tabindex', '-1')
        step.focus({ preventScroll: true })
      }

      updateProgressStepper() {
        const currentStep = this.stepTargets[this.currentStepValue]
        if (!currentStep) return

        const currentMainStep = currentStep.dataset.mainStep
        if (!currentMainStep) return

        const progressSteps = document.querySelectorAll('.quiz-progress-step[data-main-step]')
        progressSteps.forEach((progressStep) => {
          const mainStep = progressStep.dataset.mainStep
          const mainStepNum = parseInt(mainStep)
          const currentMainStepNum = parseInt(currentMainStep)

          progressStep.classList.remove('active', 'completed')

          if (mainStepNum === currentMainStepNum) {
            progressStep.classList.add('active')
            progressStep.setAttribute('aria-current', 'step')
          } else if (mainStepNum < currentMainStepNum) {
            progressStep.classList.add('completed')
            progressStep.removeAttribute('aria-current')
          } else {
            progressStep.removeAttribute('aria-current')
          }
        })
      }

      addDog() {
        Dog.create()
        this.renderDogs()
      }

      removeDog(event) {
        let dogs = Dog.all()
        let index = parseInt(event.target.closest('[data-dog-fieldset]').dataset.dog)

        if (dogs.length <= 1) return

        dogs[index].destroy()
        this.renderDogs()
      }

      renderDogs() {
        let dogs = Dog.all()
        if (dogs.length === 0) {
          Dog.create()
          dogs = Dog.all()
        }

        // If any dog doesn't have a name, we should start over
        if (dogs.some((dog) => !dog.name)) this.setCurrentStep(0)

        let replaceAttribute = (el, attr, index) => {
          if (el.hasAttribute(attr)) {
            el.setAttribute(attr, el.getAttribute(attr).replace('__INDEX__', index))
          }
        }

        this.stepTargets.forEach((step) => {
          let dogFieldsets = step.querySelectorAll('div[data-dog-fieldset]')

          let length = Math.max(dogs.length, dogFieldsets.length)
          for (let i = 0; i < length; i++) {
            let dog = dogs[i]
            let fieldset = dogFieldsets[i]

            if (!dog && fieldset) {
              fieldset.remove()
              continue
            }

            if (dog && !fieldset) {
              const template = step.querySelector('template')
              const clonedFieldsContainer = step.querySelector('div[data-fields-container]')

              if (template) {
                const content = template.content.cloneNode(true)
                clonedFieldsContainer.appendChild(content)
                fieldset = clonedFieldsContainer.lastElementChild
              }
            }

            if (dog && fieldset) {
              let index = i

              fieldset.dataset.dog = index
              const inputs = fieldset.querySelectorAll("[data-quiz-target~='input']")
              const labels = fieldset.querySelectorAll('[data-quiz-field-label]')

              inputs.forEach((input) => {
                replaceAttribute(input, 'name', index)
                replaceAttribute(input, 'id', index)
              })

              labels.forEach((label) => replaceAttribute(label, 'for', index))

              fieldset.querySelectorAll('[data-replace]').forEach((el) => {
                el.getAttribute('data-replace')
                  .split(',')
                  .forEach((attr) => replaceAttribute(el, attr.trim(), index))
                el.removeAttribute('data-replace')
              })

              // Legacy
              fieldset.querySelectorAll('[data-replace-for]').forEach((label) => {
                replaceAttribute(label, 'for', index)
                label.removeAttribute('data-replace-for')
              })
              fieldset.querySelectorAll('[data-replace-id]').forEach((el) => {
                replaceAttribute(el, 'id', index)
                el.removeAttribute('data-replace-id')
              })
              fieldset.querySelectorAll('[data-replace-aria]').forEach((el) => {
                replaceAttribute(el, 'aria-controls', index)
                replaceAttribute(el, 'aria-labelledby', index)
                el.removeAttribute('data-replace-aria')
              })
              fieldset.querySelectorAll('[data-dog-index]').forEach((input) => {
                input.dataset.dogIndex = index
              })
            }
          }
        })

        let dogCount = dogs.length
        let showButtons = dogCount > 1

        this.stepTargets.forEach((step) => {
          let removeButtons = step.querySelectorAll('.remove-dog-button')
          removeButtons.forEach((button) => {
            button.style.display = showButtons ? 'flex' : 'none'
          })
        })
      }

      isCurrentStepValid() {
        let activeStep = this.currentStepElement
        let inputs = Array.from(activeStep.querySelectorAll('[data-required]')).filter((input) => !input.disabled)

        if (inputs.length === 0) {
          this.nextButtonTarget.disabled = false
          return true
        }

        let allFilled = inputs.every((input) => {
          if (input.type === 'radio') {
            return document.querySelectorAll(`input[name="${input.name}"]:checked`).length > 0
          }

          if (input.type === 'checkbox') {
            if (input.hasAttribute('data-checkbox-multiple')) {
              let checkboxes = document.querySelectorAll(
                `input[type="checkbox"][data-checkbox-multiple][name="${input.name}"]`
              )
              return Array.from(checkboxes).some((cb) => cb.checked)
            }
            return input.checked
          }

          return input.value.trim() !== ''
        })

        return allFilled
      }

      renderButtons() {
        if (this.hasPrevButtonTarget) {
          this.prevButtonTarget.style.display = this.isFirstStep ? 'none' : ''
        }

        if (this.hasNextButtonTarget) {
          this.nextButtonTarget.textContent = this.isFirstStep
            ? 'Iniziamo'
            : this.isLastStep
              ? 'Salva e prosegui'
              : 'Prosegui'
        }

        this.nextButtonTarget.disabled = !this.isCurrentStepValid()
      }

      showLoaderModal() {
        if (!this.hasLoaderModalTarget) return

        this.loaderModalTarget.hidden = false
        this.loaderModalTarget.classList.add('dogheroes--quiz-loader-modal--visible')
      }

      scrollToTop() {
        const container = this.element.closest('.quiz-container')
        if (container) {
          container.scrollTo(0, 0)
        }
        window.scrollTo(0, 0)
      }

      saveCurrentStep() {
        let currentStep = this.currentStepValue

        let dogs = Dog.all()

        let form = this.element
        let elements = Array.from(form.elements).filter((e) => e.name)

        for (let input of elements) {
          if (input.type === 'radio' && !input.checked) continue

          const stepEl = input.closest("[data-quiz-target='step']")
          if (!stepEl) continue

          const inputStep = parseInt(stepEl.dataset.step, 10)
          if (isNaN(inputStep) || inputStep > currentStep) continue

          let index = this.getInputIndex(input)
          let key = this.getInputKey(input)
          let dog = dogs[index]
          let value = this.getInputValue(input)

          if (key != null && dog != null && value != null) {
            dog[key] = value
          }
        }

        dogs.map((dog) => {
          let calories = dog.dailyCalories()
          dog.daily_calories = Math.round(calories)
        })

        dogs.forEach((dog) => dog.save())

        // Persist customer contact fields to localStorage so they survive the
        // post-quiz navigation. The recipes page reads `customer_zip` to fetch
        // delivery timeline data, and the proceed-to-checkout flow reads all of
        // these to prefill the Shopify checkout (see assets/dogheroes--saved-cart.js).
        // NOTE: these keys are intentionally NOT read by restoreSavedCustomerData()
        // to prefill step 10 — they persist across quiz runs, so reading them
        // back on a fresh visit would leak a PREVIOUS run's contact data into
        // step 10 for anyone redoing the quiz (e.g. a shared device). The
        // bridge's own one-shot prefill uses a separate key, see
        // bridgeCustomerDataFromFragment() / restoreSavedCustomerData().
        const leadFields = {
          'dogheroes.customer_name': 'quiz[customer_name]',
          'dogheroes.customer_email': 'quiz[customer_email]',
          'dogheroes.customer_phone': 'quiz[customer_phone]',
          'dogheroes.customer_zip': 'quiz[customer_zip]',
        }
        for (let [storageKey, fieldName] of Object.entries(leadFields)) {
          let input = form.elements[fieldName]
          if (input && input.value) {
            localStorage.setItem(storageKey, input.value)
          }
        }
      }

      restoreSavedData() {
        const dogs = Dog.all()

        this.stepTargets.forEach((step) => {
          const inputs = step.querySelectorAll("[data-quiz-target~='input']")

          inputs.forEach((input) => {
            const key = this.getInputKey(input)
            const dogIndex = this.getInputIndex(input)
            const dog = dogs[dogIndex]

            if (key && dog && dog[key] != null) {
              this.setInputValue(input, dog[key])
              if (key.includes('additional_breed') && dog[key]) input.closest('details').open = true
            }
          })
        })

        this.dispatch('restoreData')
      }

      // Prefills the step 10 contact fields (dogheroes--quiz--steps--customer-data.liquid)
      // from the ONE-SHOT `dogheroes.bridge_customer` key
      // bridgeCustomerDataFromFragment() writes — and ONLY that key.
      //
      // Deliberately does NOT read the `dogheroes.customer_name/_email/
      // _phone/_zip` keys saveCurrentStep() writes: those persist across
      // quiz runs for the post-quiz checkout prefill, so reading them back
      // here would prefill step 10 with a PREVIOUS visitor's (or the same
      // visitor's previous run's) contact data for every single quiz
      // visit, bridge or not — e.g. redoing the quiz on a shared device.
      // This method must have zero effect on a non-bridge visit.
      //
      // Runs unconditionally from connect() (every visit), but is a no-op
      // unless `dogheroes.bridge_customer` is present, which only
      // bridgeCustomerDataFromFragment() ever writes. The key is removed
      // right after being read — consumed on this first application,
      // regardless of whether the JSON was valid or which fields in it
      // were usable — so it can't leak into a later quiz run either. This
      // is safe for back/forward navigation between steps: the quiz is a
      // single-page, client-side stepper (no reload between steps), so
      // connect() — and this method — runs exactly once per page load;
      // once applied, the values live in the already-rendered step 10
      // inputs like any other user input, same as the rest of the quiz.
      //
      // Skips a field that's already filled (e.g. a logged-in customer's
      // readonly value rendered server-side from `customer`) so this never
      // overwrites known-good data. Never touches `consent_marketing`
      // itself — returns the parsed bridgeCustomer object (or null) so
      // connect() can pass it to maybeAutoSubmitFromBridge(), which is the
      // only place that may tick that checkbox.
      restoreSavedCustomerData() {
        const raw = localStorage.getItem('dogheroes.bridge_customer')
        if (!raw) return null

        localStorage.removeItem('dogheroes.bridge_customer')

        let bridgeCustomer
        try {
          bridgeCustomer = JSON.parse(raw)
        } catch {
          return null
        }
        if (!bridgeCustomer || typeof bridgeCustomer !== 'object') return null

        for (let fieldName of ['customer_name', 'customer_email', 'customer_phone', 'customer_zip']) {
          const value = bridgeCustomer[fieldName]
          if (!value) continue

          const input = this.element.querySelector(`[data-quiz-field="${fieldName}"]`)
          if (!input || input.readOnly || input.value) continue

          input.value = value
        }

        return bridgeCustomer
      }

      // Decision (Marco, 10/2026): a visitor who arrives from the Link Hub
      // bridge with ALL of (a) full customer data, (b) explicit marketing
      // consent given in the hub with the SAME text/links as the
      // `quiz[consent_marketing]` checkbox, and (c) dog data already
      // complete (the bridge landed straight on step 10, the last step,
      // per bridgeFirstIncompleteStep()) should not have to press "Salva e
      // prosegui" themselves — the quiz ticks that box and submits for
      // them, straight to /pages/recipes. Anything short of that — missing
      // consent, missing/invalid contact field, or dog data that was
      // incomplete (landed on an earlier step) — falls back to exactly
      // today's behaviour: prefill what's known, consent box left
      // unchecked, the visitor finishes and presses the button by hand.
      //
      // `bridgeCustomer` is the value connect() got back from
      // restoreSavedCustomerData() — null on every non-bridge visit, and
      // also null on a reload/back-navigation AFTER this ran once, because
      // that method already deleted the one-shot `dogheroes.bridge_customer`
      // key the first time around. That's what makes this safe against a
      // double submit: the auto-submit can fire at most once per bridge
      // arrival, not once per connect() (e.g. a `pageshow` from bfcache, or
      // the user hitting back after being redirected to /pages/recipes).
      //
      // Never auto-submits for a logged-in customer (customerIdValue set):
      // their step 10 fields are readonly and already hold THEIR account
      // data, which may differ from what the hub sent — silently mixing
      // the two, or submitting on their behalf without them seeing the
      // final screen, would be wrong. They always get the manual flow.
      //
      // Safety net against async nested-widget restore (flagged on review,
      // 08/10/2026): the dog fields (steps 0-9) are set by restoreSavedData()
      // directly on the DOM, synchronously, before this method's own
      // await point below — but several of those steps render a NESTED
      // Stimulus controller (dogheroes--ui--select-breed,
      // dogheroes--ui--age-input, dogheroes--ui--health-issues, the
      // range-slider build/activity inputs, …) that connects on its own,
      // slightly later, via Stimulus's own MutationObserver-driven
      // scheduling rather than inline with this controller's connect().
      // Some of those controllers run logic on THEIR OWN connect() that
      // can rewrite a field — e.g. dogheroes--ui--health-issues reads
      // `yesTarget.checked` on connect() and, if it reads false at that
      // instant, unchecks every disease checkbox. Today's code is believed
      // to already be safe (restoreSavedData() finishes, synchronously,
      // before any such nested connect() can run — see the PR discussion),
      // but relying on exact microtask/MutationObserver ordering across
      // browsers for a flow that SKIPS the screen a manual visitor would
      // see and could catch a mismatch on is exactly the kind of thing
      // that's cheap to double-check and expensive to get wrong (wrong
      // calories, a metaobject missing the breed, with nobody looking at
      // the result before it's sent). So: wait for the live DOM to match
      // the Dog the bridge actually saved (waitForBridgeDogRestore(),
      // which polls bridgeDogFieldsMatch() below), give up after 5s and
      // leave the manual flow in place, and re-check once more immediately
      // before calling submitQuiz().
      async maybeAutoSubmitFromBridge(bridgeCustomer) {
        if (!bridgeCustomer) return
        if (this.customerIdValue) return
        if (bridgeCustomer.consent !== true) return
        if (!this.isLastStep) return

        const customerFields = ['customer_name', 'customer_email', 'customer_phone', 'customer_zip']
        if (!customerFields.every((field) => Boolean(bridgeCustomer[field]))) return

        const dog = Dog.all()[0]
        if (!dog) return

        const restored = await this.waitForBridgeDogRestore(dog)
        if (!restored) return // timed out: leave the manual flow in place, nothing to undo

        // Re-read: the wait yields to the event loop, so re-confirm nothing
        // changed underneath us (e.g. the visitor clicked "indietro" while
        // we were waiting — the page is NOT blocked by the loader yet).
        if (!this.isLastStep) return

        const consentInput = this.element.querySelector('[data-quiz-field="consent_marketing"]')
        if (!consentInput || consentInput.readOnly) return
        consentInput.checked = true

        if (!this.isCurrentStepValid()) return
        // Final guard, right before submitting: re-run the exact same
        // comparison one last time with no await in between this check and
        // submitQuiz() below.
        if (!this.bridgeDogFieldsMatch(dog)) return

        this.submitQuiz()
      }

      // Polls bridgeDogFieldsMatch() (below) every animation frame until it
      // passes or `timeoutMs` elapses, whichever comes first. Resolves
      // `true`/`false` accordingly — never rejects. See the comment on
      // maybeAutoSubmitFromBridge() above for why this exists.
      waitForBridgeDogRestore(dog, timeoutMs = 5000) {
        return new Promise((resolve) => {
          const start = Date.now()
          const check = () => {
            if (this.bridgeDogFieldsMatch(dog)) {
              resolve(true)
              return
            }
            if (Date.now() - start >= timeoutMs) {
              resolve(false)
              return
            }
            requestAnimationFrame(check)
          }
          check()
        })
      }

      // Dry-run equivalent of saveCurrentStep(): reads the SAME live DOM
      // inputs (steps 0-9, dog index 0) with the SAME helpers
      // (getInputKey/getInputIndex/getInputValue) but returns the values
      // instead of writing them into the Dog, so they can be compared
      // against it without side effects.
      collectLiveDogFields() {
        const values = {}

        this.stepTargets.forEach((step) => {
          const stepIndex = parseInt(step.dataset.step, 10)
          if (isNaN(stepIndex) || stepIndex > 9) return // step 10 is customer data, not dog data

          const inputs = Array.from(step.querySelectorAll("[data-quiz-target~='input']")).filter((input) => input.name)

          inputs.forEach((input) => {
            if (input.type === 'radio' && !input.checked) return
            if (this.getInputIndex(input) !== 0) return

            const key = this.getInputKey(input)
            if (key == null) return

            const value = this.getInputValue(input)
            if (value != null) values[key] = value
          })
        })

        return values
      }

      // Field-by-field comparison between the live DOM (as
      // collectLiveDogFields() above reads it) and the Dog object the
      // bridge actually saved (handleBridge(), before the reload that
      // led here). Only compares the fields the bridge explicitly set
      // (non-null on `dog`) — anything the bridge left unset was never
      // its concern. Returns false on ANY mismatch, which aborts the
      // auto-submit (see maybeAutoSubmitFromBridge() above).
      bridgeDogFieldsMatch(dog) {
        const live = this.collectLiveDogFields()

        const scalarKeys = [
          'breed',
          'sex',
          'sterilization',
          'birthday',
          'birthday_type',
          'weight',
          'build',
          'activity',
          'hunger',
          'has_diseases',
        ]
        for (const key of scalarKeys) {
          const expected = dog[key]
          if (expected == null) continue
          if (String(live[key] ?? '') !== String(expected)) return false
        }

        const sameSet = (a, b) => {
          const as = new Set(Array.isArray(a) ? a : [])
          const bs = new Set(Array.isArray(b) ? b : [])
          return as.size === bs.size && Array.from(as).every((value) => bs.has(value))
        }

        if (Array.isArray(dog.diet) && !sameSet(live.diet, dog.diet)) return false
        if (Array.isArray(dog.allergies) && !sameSet(live.allergies, dog.allergies)) return false
        if (dog.has_diseases === 'yes' && Array.isArray(dog.diseases) && !sameSet(live.diseases, dog.diseases)) {
          return false
        }

        return true
      }

      getInputKey(input) {
        const match = input.name.match(/quiz\[\w+\]\[(\w+)\]/)
        return match ? match[1] : null
      }

      getInputIndex(input) {
        const match = input.name.match(/quiz\[(\w+)\]\[\w+\]/)
        return match ? parseInt(match[1], 10) : null
      }

      getInputValue(input) {
        if (input.type === 'checkbox' && input.hasAttribute('data-checkbox-multiple')) {
          let allCheckboxes = input.form.querySelectorAll(
            `input[type="checkbox"][data-checkbox-multiple][name="${input.name}"]`
          )
          let checkedValues = Array.from(allCheckboxes)
            .filter((cb) => cb.checked)
            .map((cb) => cb.value)
          return checkedValues
        }

        if (input.type === 'checkbox') {
          return input.checked ? 'yes' : 'no'
        }
        return input.value
      }

      updateDogNamePlaceholders() {
        let dogNames = Dog.all().map((dog) => dog.displayName)
        // Dog names are free text (including, since the URL bridge above, text
        // that came straight from a query param): escape before building HTML.
        let escapeHtml = (value) =>
          String(value).replace(
            /[&<>"']/g,
            (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]
          )
        let dogNameElements = dogNames.map((name) => `<span>${escapeHtml(name)}</span>`)
        // Join with a comma, use "e" for the last separator
        let joinedDogNames =
          dogNameElements.slice(0, -1).join(', ') +
          (dogNameElements.length > 1 ? ' e ' : '') +
          dogNameElements.slice(-1)

        this.element.querySelectorAll('[data-dog-names]').forEach((el) => {
          el.innerHTML = joinedDogNames
        })

        this.stepTargets.forEach((step) => {
          const groupedByDog = step.querySelectorAll('[data-dog-fieldset]')
          groupedByDog.forEach((group, index) => {
            const dogNamePlaceholders = group.querySelectorAll('[data-dog-name]')

            dogNamePlaceholders.forEach((el) => {
              el.textContent = dogNames[index]
            })
          })
        })
      }

      setInputValue(input, value) {
        if (input.type === 'checkbox') {
          if (input.hasAttribute('data-checkbox-multiple')) {
            input.checked = Array.isArray(value) && value.includes(input.value)
          } else {
            input.checked = value === 'yes'
          }
        } else if (input.type === 'radio') {
          input.checked = input.value === value
        } else {
          const rangeSlider = input.closest('range-slider')
          if (rangeSlider) {
            rangeSlider.dataset.selectedHandle = value
          }
          input.value = value
        }
      }

      sanitizePhone(event) {
        const input = event.target
        let value = input.value
        value = value.replace(/[^\d]/g, '')

        if (value.length > 10) {
          value = value.slice(0, 10)
        }

        if (value.length > 6) {
          value = `${value.slice(0, 3)} ${value.slice(3, 6)} ${value.slice(6)}`
        } else if (value.length > 3) {
          value = `${value.slice(0, 3)} ${value.slice(3)}`
        }

        input.value = value
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--recipes--steps--cart-recap"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'cart-recap',
    class extends Stimulus.Controller {
      static targets = [
        'discountedPrice',
        'discountPercentage',
        'dogsContainer',
        'dailyPrice',
        'trialDeliveryDate',
        'trialTotalPrice',
        'paymentReminderDate',
        'subscriptionStartDate',
        'subscriptionPrice',
        'entireDailyPrice',
        'totalPrice',
      ]

      static values = {
        discount: Number,
      }

      connect() {
        const discountPercentage = DogHeroes.discountPercentage ?? 40

        this.discountValue = discountPercentage
        this.element.dataset.cartRecapDiscountValue = String(discountPercentage)
        if (this.hasDiscountPercentageTarget) {
          this.discountPercentageTarget.textContent = String(discountPercentage)
        }

        this.#syncTrialPriceFromFooter()
        this.totalPriceObserver = new MutationObserver(() => this.#syncTrialPriceFromFooter())
        this.totalPriceObserver.observe(this.totalPriceTarget, {
          childList: true,
          characterData: true,
          subtree: true,
        })
      }

      disconnect() {
        this.totalPriceObserver?.disconnect()
      }

      async loadTimeline() {
        // The CAP (ZIP) is persisted to localStorage by the quiz on /pages/quiz
        // (see dogheroes--quiz.liquid `saveCurrentStep`). On /pages/recipes we
        // read it back and ask the backend for delivery-aware timeline data.
        this.#renderFinalPrices()

        const zip = localStorage.getItem('dogheroes.customer_zip') || '00000'
        const hasFrozen = this.#hasFrozenProducts()
        const data = await this.fetchTimelineData(zip, hasFrozen)
        if (!data) return

        this.renderTimeline(data)
      }

      #hasFrozenProducts() {
        const subscriptions = DogHeroes.savedCart?.subscriptions || []
        const products = DogHeroes.productsByHandle || {}

        return subscriptions.some((subscription) => {
          return Object.values(subscription).some((recipe) => {
            const productHandle = recipe.productHandle
            const product = products[productHandle]
            return product?.tags?.includes('frozen')
          })
        })
      }

      async fetchTimelineData(zip, hasFrozen = false) {
        const url = new URL('https://dogheroes-production-68e629138b57.herokuapp.com/delivery_dates')
        url.searchParams.set('cap', zip)
        if (hasFrozen) {
          url.searchParams.set('has_frozen', 'true')
        }

        try {
          const response = await fetch(url)
          if (!response.ok) throw new Error('Network response was not ok')
          return await response.json()
        } catch (error) {
          console.error('Failed to fetch timeline data:', error)
          return null
        }
      }

      renderTimeline(data) {
        const earliest = new Date(data.earliest)
        const trialDeliveryDate = earliest.toLocaleDateString('it-IT', {
          day: 'numeric',
          month: 'long',
        })
        this.trialDeliveryDateTarget.textContent = `${trialDeliveryDate}`

        const paymentReminderDate = new Date(earliest)
        paymentReminderDate.setDate(paymentReminderDate.getDate() + 10)
        this.paymentReminderDateTarget.textContent = `${paymentReminderDate.toLocaleDateString('it-IT', {
          day: 'numeric',
          month: 'long',
        })}`

        const subscriptionStartDate = new Date(earliest)
        subscriptionStartDate.setDate(subscriptionStartDate.getDate() + 14)
        this.subscriptionStartDateTarget.textContent = `${subscriptionStartDate.toLocaleDateString('it-IT', {
          day: 'numeric',
          month: 'long',
        })}`
      }

      updatePrices(event) {
        const { savedCart } = event.detail

        const dailyPrice = DogHeroes.savedCart.subscriptionsDailySubtotal(14)
        const discountedDailyPrice = (dailyPrice * (1 - this.discountValue / 100)) / 100

        this.discountedPriceTarget.textContent = `€${discountedDailyPrice.toFixed(2).replace('.', ',')}`
        this.dailyPriceTarget.textContent = `€${(dailyPrice / 100).toFixed(2).replace('.', ',')}`
        this.entireDailyPriceTarget.textContent = `€${(dailyPrice / 100).toFixed(2).replace('.', ',')}`
        this.subscriptionPriceTarget.textContent = `€${((dailyPrice * 28) / 100).toFixed(2).replace('.', ',')}`
        this.#renderFinalPrices()

        this.renderDogs(savedCart)
        this.renderOneTimePurchases()
      }

      #finalTotalCents() {
        // "Box di prova" is an ORDER-level automatic discount (a single
        // percentage off the whole subscription subtotal, first payment only),
        // so Shopify computes it once on the subtotal and rounds. Replicate
        // that exactly: summing per-line floors under-counts the discount and
        // drifts a cent or two above the real checkout total.
        const subscriptionSubtotalCents = DogHeroes.savedCart.subscriptions.reduce((total, dogSubscriptions) => {
          return (
            total +
            Object.values(dogSubscriptions).reduce((subtotal, { quantity, price }) => subtotal + quantity * price, 0)
          )
        }, 0)
        const discountedSubscriptionsCents =
          subscriptionSubtotalCents - Math.round((subscriptionSubtotalCents * this.discountValue) / 100)
        const oneTimeCents = Math.round(DogHeroes.savedCart.oneTimePurchasesTotal * 100)
        return discountedSubscriptionsCents + oneTimeCents
      }

      #renderFinalPrices() {
        const finalTotal = `€${(this.#finalTotalCents() / 100).toFixed(2).replace('.', ',')}`
        this.trialTotalPriceTarget.textContent = finalTotal
        this.totalPriceTarget.textContent = finalTotal
      }

      #syncTrialPriceFromFooter() {
        const totalPrice = this.totalPriceTarget.textContent?.trim()
        if (!totalPrice) return
        this.trialTotalPriceTarget.textContent = totalPrice
      }

      renderDogs(savedCart) {
        const dogs = DogHeroes.Dog.all()
        const container = this.dogsContainerTarget

        container.querySelectorAll('[data-rendered]').forEach((el) => el.remove())

        dogs.forEach((dog, dogIndex) => {
          const subscriptions = savedCart?.subscriptions?.[dogIndex] || {}
          const entries = Object.values(subscriptions)
          if (entries.length === 0) return

          const totalGrams = entries.reduce(
            (sum, { quantity, weightInGrams }) => sum + (quantity || 0) * (weightInGrams || 0),
            0
          )
          const dailyGrams = Math.round(totalGrams / 14)

          const fragment = DogHeroes.render('cart-recap-dog-template', {
            'dog-name': dog.displayName,
            'daily-grams': String(dailyGrams),
            quantity: entries.reduce((sum, { quantity }) => sum + (quantity || 0), 0),
          })

          const el = fragment.firstElementChild
          if (el) {
            el.setAttribute('data-rendered', '')

            const firstProductHandle = entries[0]?.productHandle
            const sourceImg = firstProductHandle
              ? container.querySelector(`[data-product-image-for="${firstProductHandle}"] img`)
              : null
            const targetImg = el.querySelector('.image img')
            if (sourceImg && targetImg) {
              targetImg.src = sourceImg.src
              targetImg.alt = sourceImg.alt
            }
          }

          container.appendChild(fragment)
        })
      }

      // One-off products (crunchy bites) picked on the cross-sell step. They
      // live in savedCart.oneTimePurchases keyed by variant id; the product
      // title/variant/image come from the hidden cross-sell data block below,
      // keyed by the same variant id.
      renderOneTimePurchases() {
        const container = this.dogsContainerTarget
        container.querySelectorAll('[data-one-time-rendered]').forEach((el) => el.remove())

        const oneTimePurchases = DogHeroes.savedCart?.oneTimePurchases || {}

        Object.entries(oneTimePurchases).forEach(([variantId, { quantity }]) => {
          if (!quantity) return

          const source = container.querySelector(`[data-one-time-variant="${variantId}"]`)
          if (!source) return

          const fragment = DogHeroes.render('cart-recap-one-time-template', {
            title: source.dataset.title,
            'variant-title': source.dataset.variantTitle,
            quantity: String(quantity),
          })

          const el = fragment.firstElementChild
          if (el) {
            el.setAttribute('data-one-time-rendered', '')

            const sourceImg = source.querySelector('img')
            const targetImg = el.querySelector('.image img')
            if (sourceImg && targetImg) {
              targetImg.src = sourceImg.src
              targetImg.alt = sourceImg.alt
            }
          }

          container.appendChild(fragment)
        })
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--recipes--steps--cross-sell"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'cross-sell',
    class extends Stimulus.Controller {
      static targets = ['counter', 'variant', 'buttonText']

      get cart() {
        return DogHeroes.savedCart
      }

      connect() {}

      increment(event) {
        let index = event.params.index
        let { id, quantity, price } = this.variantTargets[index].dataset
        let updatedQuantity = parseInt(quantity) + 1

        this.variantTargets[index].dataset.quantity = updatedQuantity
        this.counterTargets[index].textContent = updatedQuantity
        this.updateItems(id, updatedQuantity, price / 100)
      }

      decrement(event) {
        let index = event.params.index
        let { id, quantity, price } = this.variantTargets[index].dataset

        if (quantity > 0) {
          let updatedQuantity = parseInt(quantity) - 1
          this.variantTargets[index].dataset.quantity = updatedQuantity
          this.counterTargets[index].textContent = updatedQuantity
          this.updateItems(id, updatedQuantity, price / 100)
        }
      }

      updateItems(id, quantity, price) {
        let itemId = parseInt(id)

        if (quantity === 0) {
          delete this.cart.oneTimePurchases[itemId]
        } else {
          this.cart.oneTimePurchases[itemId] = {
            quantity,
            price: parseFloat(price),
          }
        }

        this.updateButton()
        this.dispatch('quantityUpdated')
      }

      updateButton() {
        let total = this.cart.oneTimePurchasesTotal
        if (total > 0) {
          this.buttonTextTarget.textContent = `Aggiungi • €${total.toFixed(2).replace('.', ',')}`
        } else {
          this.buttonTextTarget.textContent = 'Prosegui'
        }
      }

      async submitForm(event) {
        event.preventDefault()

        // Fire one extra_selected per dog on every pass through the step, even
        // with no extras picked, so the data layer always records it.
        this.#pushExtraSelectedEvents()

        let itemsToAdd = Object.entries(this.cart.oneTimePurchases).map(([id, item]) => ({
          id: parseInt(id),
          quantity: item.quantity,
        }))

        if (itemsToAdd.length === 0) return

        try {
          let response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: itemsToAdd }),
          })
          if (!response.ok) {
            console.error('Failed to add items to cart. Response status:', response.status)
          }
        } catch (error) {
          console.error('Network error while adding items to cart:', error)
        }
      }

      #pushExtraSelectedEvents() {
        let extraProducts = this.#extraProductsText()

        DogHeroes.Dog.all().forEach((dog, index) => {
          let recipes = Object.values(this.cart.subscriptions[index] || {})
          DogHeroes.pushToDataLayer({
            event: 'extra_selected',
            quiz_type: 'dog',
            food_type: recipes[0]?.recipeType ?? null,
            dogs: [DogHeroes.serializeDog(dog)],
            recipes: DogHeroes.recipesText(recipes),
            extra_products: extraProducts,
            ...DogHeroes.dogPriceFields(recipes),
          })
        })
      }

      // The chosen extras as text, e.g. "Crunchy Bites Fragola, Ciotola portatile".
      #extraProductsText() {
        return this.variantTargets
          .filter((variant) => parseInt(variant.dataset.quantity) > 0)
          .map((variant) => variant.dataset.productTitle)
          .join(', ')
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--recipes--steps--variants-picker"] && !Shopify.designMode) return;
  try {
    const { Dog } = DogHeroes

  Stimulus.register(
    'variants-picker',
    class extends Stimulus.Controller {
      static targets = [
        'recipe',
        'frozenRecipe',
        'pantryRecipe',
        'price',
        'suggestedRecipes',
        'notSuggestedRecipes',
        'otherRecipes',
        'title',
      ]

      static values = {
        portionsTable: Array,
        blockingHealthProblems: Array,
        discount: Number,
      }

      connect() {
        this.index = parseInt(this.element.dataset.index)
        this.dog = Dog.find(this.index)

        const discountPercentage = DogHeroes.discountPercentage ?? 40

        this.discountValue = discountPercentage
        this.element.dataset.variantsPickerDiscountValue = String(discountPercentage)

        this.calculateRecipeVariantsAndQuantities()
        this.replaceIndex()
        this.replaceDogName()
        this.moveRecipesToCorrectContainers()
      }

      get intervalDays() {
        return DogHeroes.intervalDays || 14
      }

      get variants() {
        return DogHeroes.variants || []
      }

      get allSellingPlanGroupsByProduct() {
        return DogHeroes.allSellingPlanGroupsByProduct || []
      }

      replaceDogName() {
        const nameElements = this.element.querySelectorAll('span[data-dog-name]')
        nameElements.forEach((element) => {
          element.textContent = this.dog.name
        })
      }

      replaceIndex() {
        const labels = this.element.querySelectorAll('[data-replace-for]')
        labels.forEach((label) => {
          const forValue = label.getAttribute('for')
          label.setAttribute('for', forValue.replace('_INDEX_', this.index))
        })

        const ids = this.element.querySelectorAll('[data-replace-id]')
        ids.forEach((input) => {
          const idValue = input.getAttribute('id')
          input.setAttribute('id', idValue.replace('_INDEX_', this.index))
        })
      }

      moveRecipesToCorrectContainers() {
        // "ovino" matches both "sheep" (frozen) and "lamb" (pantry) products.
        const allergyMapping = {
          pollo: ['chicken'],
          manzo: ['beef'],
          pesce: ['fish'],
          tacchino: ['turkey'],
          anatra: ['duck'],
          cervo: ['deer'],
          coniglio: ['rabbit'],
          maiale: ['pork'],
          ovino: ['sheep', 'lamb'],
        }

        const isAllergic = (productTitle) =>
          this.dog.allergies.some((allergy) =>
            (allergyMapping[allergy] || []).some((keyword) => productTitle.toLowerCase().includes(keyword))
          )

        const dogDiseases = this.dog.diseases || []
        const hasBlockingHealthProblem = dogDiseases.some((disease) =>
          this.blockingHealthProblemsValue.includes(disease)
        )

        const suggestedContainer = this.suggestedRecipesTarget.querySelector('.container')
        const notSuggestedContainer = this.notSuggestedRecipesTarget.querySelector('.container')

        this.recipeTargets.forEach((target) => {
          const productTitle = target.dataset.productTitle
          const isSuggested = target.dataset.isSuggested === 'true'

          if (hasBlockingHealthProblem) {
            const clonedTarget = target.cloneNode(true)
            notSuggestedContainer.appendChild(clonedTarget)
            target.remove()
          } else if (isAllergic(productTitle)) {
            const clonedTarget = target.cloneNode(true)
            notSuggestedContainer.appendChild(clonedTarget)
            target.remove()
          } else if (isSuggested) {
            const clonedTarget = target.cloneNode(true)
            suggestedContainer.appendChild(clonedTarget)
            target.remove()
          }
        })
      }

      hideEmptyContainers(recipeType) {
        const hasChildrenOfType = (container, type) => container.querySelector(`[data-recipe-type="${type}"]`) !== null

        const suggestedContainer = this.suggestedRecipesTarget.querySelector('.container')
        const notSuggestedContainer = this.notSuggestedRecipesTarget.querySelector('.container')
        const otherRecipesContainer = this.otherRecipesTarget.querySelector('.container')

        this.suggestedRecipesTarget.style.display = hasChildrenOfType(suggestedContainer, recipeType) ? '' : 'none'

        this.notSuggestedRecipesTarget.style.display = hasChildrenOfType(notSuggestedContainer, recipeType)
          ? ''
          : 'none'

        this.otherRecipesTarget.style.display = hasChildrenOfType(otherRecipesContainer, recipeType) ? '' : 'none'
      }

      preselectSuggestedRecipes(event) {
        let selectedRecipeType = event.detail.selectedType

        if (this.element.style.display !== 'none') {
          this.suggestedRecipesTarget.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
            if (checkbox.closest('[data-recipe-type]').dataset.recipeType !== selectedRecipeType) return

            checkbox.checked = true
            this.toggleRecipeSelection({ target: checkbox })
          })
        }

        this.hideEmptyContainers(selectedRecipeType)
      }

      calculateRecipeVariantsAndQuantities() {
        let calories = this.dog.daily_calories
        let portion = null

        if (calories > 2500) {
          portion = this.portionsTableValue[this.portionsTableValue.length - 1]
        } else {
          portion = this.portionsTableValue.find((entry) => {
            return calories >= entry.minCalories && calories <= entry.maxCalories
          })
        }

        this.recipeTargets.forEach((productTarget) => {
          this.calculateVariantAndQuantity(productTarget, portion)
        })
      }

      calculateVariantAndQuantity(target, portion) {
        const recipeType = target.dataset.recipeType

        const { variantId, quantity, price, sellingPlanId, weightInGrams } = this.getVariantAndQuantity(
          JSON.parse(target.dataset.variantIds),
          portion,
          recipeType
        )

        const checkbox = target.querySelector("input[type='checkbox']")
        checkbox.dataset.variantId = variantId
        checkbox.dataset.variantQuantity = quantity
        checkbox.dataset.variantPrice = price.toFixed(2)
        checkbox.dataset.sellingPlanId = sellingPlanId
        checkbox.dataset.weightInGrams = weightInGrams

        const lineCents = price * quantity
        const dailyCents = lineCents / this.intervalDays
        const discountPercent = this.discountValue || 40
        // Round to the nearest cent (NOT floor) and mirror the exact
        // expression the cart-recap headline uses (cart-recap.liquid
        // updatePrices: `(dailyPrice * (1 - discount / 100)) / 100`), so the
        // per-recipe daily price shown on this card and the recap's daily
        // price are always identical.
        const discountedDaily = (dailyCents * (1 - discountPercent / 100)) / 100

        target.querySelector('[data-variant-original-price-container]').textContent = `€ ${(dailyCents / 100)
          .toFixed(2)
          .replace('.', ',')}`
        target.querySelector('[data-variant-price-container]').textContent = `€ ${discountedDaily
          .toFixed(2)
          .replace('.', ',')}`
      }

      getVariantAndQuantity(variantIds, portion, recipeType) {
        let variantIndex = portion?.portions[recipeType].variantIndex
        let multiplier = portion?.portions[recipeType].multiplier
        let variantId = variantIds[variantIndex]
        let quantity = Math.ceil(multiplier * this.intervalDays)

        const variantInfo = this.variants.find((variant) => variant.variant_id == variantId)

        let sellingPlanGroup = null

        if (recipeType === 'frozen') {
          const allSellingPlanGroups = this.allSellingPlanGroupsByProduct.find(
            (spg) => spg.product_id === variantInfo.product_id
          ).selling_plan_groups

          const sellingPlanGroups = allSellingPlanGroups.filter((spg) =>
            variantInfo.selling_plan_group_ids.includes(spg.id)
          )

          switch (multiplier) {
            case 0.5:
            case 1:
              if (sellingPlanGroups.length == 1) {
                sellingPlanGroup = sellingPlanGroups[0]
              } else {
                sellingPlanGroup = sellingPlanGroups.find((spg) => !spg.name.toLowerCase().includes('x'))
              }
              break
            case 2:
              sellingPlanGroup = sellingPlanGroups.find((spg) => spg.name.toLowerCase().includes('x2'))
              break
            case 3:
              sellingPlanGroup = sellingPlanGroups.find((spg) => spg.name.toLowerCase().includes('x3'))
              break
          }
        } else {
          const sellingPlanGroupsByProduct = this.allSellingPlanGroupsByProduct.find(
            (spg) => spg.product_id === variantInfo.product_id
          ).selling_plan_groups

          const regex = /\((\d+)-(\d+)\)/
          const productsCount = Math.ceil(multiplier * this.intervalDays)

          if (productsCount < 6) {
            sellingPlanGroup = sellingPlanGroupsByProduct[0]
          } else {
            sellingPlanGroup = sellingPlanGroupsByProduct.find((spg) => {
              const match = regex.exec(spg.name)
              if (match) {
                const min = parseInt(match[1])
                const max = parseInt(match[2])
                return productsCount >= min && productsCount <= max
              }
              return false
            })
          }
        }

        const sellingPlan = sellingPlanGroup.selling_plans.find((sp) => sp.name === 'Box di prova')

        return {
          variantId,
          quantity,
          price: sellingPlan.price_adjustments[0].value,
          sellingPlanId: sellingPlan.id,
          weightInGrams: variantInfo.weight_in_grams,
        }
      }

      toggleRecipeSelection(event) {
        const checkbox = event.target

        this.dispatch('recipeToggled', {
          detail: {
            variantId: parseInt(checkbox.dataset.variantId),
            quantity: parseInt(checkbox.dataset.variantQuantity),
            price: parseInt(checkbox.dataset.variantPrice),
            productTitle: checkbox.dataset.productTitle,
            productHandle: checkbox.dataset.productHandle,
            sellingPlanId: checkbox.dataset.sellingPlanId,
            weightInGrams: parseInt(checkbox.dataset.weightInGrams),
            recipeType: checkbox.closest('[data-recipe-type]')?.dataset.recipeType,
            index: this.index,
            selected: checkbox.checked,
          },
        })
      }
    }
  )

  // NOTE: Portions table data is injected from shop.metafields.custom.portions_table
  // via the <script> tag at the top of this snippet. Use Shop#save_portions_table_dump
  // from the Rails console to update it.
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--recipes"] && !Shopify.designMode) return;
  try {
    const { Dog } = DogHeroes

  Stimulus.register(
    'recipes-selector',
    class extends Stimulus.Controller {
      static values = {
        selectedRecipeTypeStorageKey: { type: String, default: 'selectedRecipeType' },
      }

      static targets = [
        'step',
        'singleDogHeader',
        'multipleDogHeader',
        'variantPickerTemplate',
        'variantPicker',
        'cartButton',
        'headerBackButton',
        'headerBackToQuizButton',
        'badgeContainer',
        'badgeContainerTemplate',
        'badgeTemplate',
        'dogTemplate',
        'frozenRecipe',
        'pantryRecipe',
        'totalPrice',
        'pickerTitle',
      ]

      get cart() {
        if (!DogHeroes.savedCart) DogHeroes.savedCart = new DogHeroes.SavedCart(this.dogs)

        return DogHeroes.savedCart
      }

      async connect() {
        this.dogs = Dog.all()

        const discountPercentage = DogHeroes.discountPercentage ?? 40
        this.element.dataset.cartDiscountValue = String(discountPercentage)

        // NOTE: Keep in sync with MealPlan::PANTRY_MIN_CALORIES in dogheroes-app
        const PANTRY_MIN_CALORIES = 151
        const PANTRY_MIN_AGE_MONTHS = 12
        const pantryAvailable = this.dogs.every(
          (dog) => dog.dailyCalories() >= PANTRY_MIN_CALORIES && dog.age.inMonths > PANTRY_MIN_AGE_MONTHS
        )
        if (!pantryAvailable) {
          const pantryBtn = this.element.querySelector('[data-recipes-selector-type-param="pantry"]')
          if (pantryBtn) {
            pantryBtn.disabled = true
            pantryBtn.style.opacity = '0.4'
            pantryBtn.style.pointerEvents = 'none'
          }
        }

        this.currentStep = 0
        this.selectedDogIndex = 0
        this.selectedRecipeType = 'frozen'

        this.#renderBadges()
        this.#renderSelectedRecipeType()
        this.#renderDogNamePlaceholders()
        this.#renderDogsSelector()
        this.#renderHeader()
        this.#renderVariantPickers()

        this.#renderCurrentStep()

        this.headerBackButtonTarget.style.display = 'none'

        DogHeroes.selectedDogIndex = this.selectedDogIndex
      }

      selectRecipeType(event) {
        let newType = event.params.type

        if (newType !== this.selectedRecipeType) {
          this.cart.clearSubscription(this.selectedDogIndex)
          this.variantPickerTargets[this.selectedDogIndex]
            ?.querySelectorAll("input[type='checkbox']")
            .forEach((checkbox) => (checkbox.checked = false))
        }

        this.selectedRecipeType = newType
        this.#renderSelectedRecipeType()
        this.dispatch('recipeTypeSelected', { detail: { selectedType: this.selectedRecipeType } })
        this.#pushFoodTypeSelectedEvent()
        this.next()
      }

      selectDog(event) {
        let index = parseInt(event.target.dataset.index)

        this.selectedDogIndex = index
        DogHeroes.selectedDogIndex = index

        let headerTitles = this.multipleDogHeaderTarget.querySelectorAll('div[data-index]')
        headerTitles.forEach((el) => el.removeAttribute('data-selected'))
        headerTitles[index].setAttribute('data-selected', 'true')

        if (this.cart.recipeCountFor(index) === 0) {
          this.cartButtonTarget.setAttribute('disabled', 'true')
        }

        this.#displayCorrectVariantPicker(index)
        this.currentStep = 0
        this.#renderCurrentStep()
        this.headerBackButtonTarget.style.display = 'none'
        this.headerBackToQuizButtonTarget.style.display = ''

        this.badgeContainerTargets.forEach((container) => {
          container.style.display = container.dataset.index === String(index) ? 'flex' : 'none'
        })
      }

      next() {
        let fromStep = this.currentStep
        this.currentStep++

        // Leaving the variants picker means recipes are confirmed for the
        // selected dog — one event per dog (multi-dog fires it N times).
        if (fromStep === 1) this.#pushRecipeSelectedEvents()

        if (this.cart.allDogsHaveRecipes) {
          this.multipleDogHeaderTarget.style.display = 'none'
          this.singleDogHeaderTarget.style.display = 'none'
          this.badgeContainerTarget.style.display = 'none'
        }

        if (this.currentStep === 2) {
          this.dispatch('productsSelected', { bubbles: true })
        }

        this.headerBackButtonTarget.style.display = ''
        this.headerBackToQuizButtonTarget.style.display = 'none'
        this.#renderCurrentStep()
      }

      previous() {
        if (this.currentStep === 0) window.location.href = '/pages/quiz'

        this.currentStep--

        if (this.currentStep <= 1) {
          this.#renderHeader()
          this.badgeContainerTargets.forEach((container) => {
            container.style.display = container.dataset.index === String(this.selectedDogIndex) ? 'flex' : 'none'
          })
        }

        if (this.currentStep === 0) {
          this.headerBackButtonTarget.style.display = 'none'
          this.headerBackToQuizButtonTarget.style.display = ''
        }

        this.#renderCurrentStep()
      }

      updateSelectedRecipes(event) {
        let { index, variantId, selected, ...recipeData } = event.detail

        if (selected) {
          this.cart.addRecipe(index, variantId, recipeData)
        } else {
          this.cart.removeRecipe(index, variantId, recipeData)
        }

        this.updateTotalPrice()
        this.dispatch('selectedRecipesUpdated', { detail: { savedCart: this.cart } })
      }

      updateTotalPrice() {
        const discount = Number.parseFloat(this.element.dataset.cartDiscountValue || '40')
        const discountPercentage = Number.isFinite(discount) ? discount : 40
        // "Box di prova" is an ORDER-level automatic discount (a single
        // percentage off the whole subscription subtotal, first payment only),
        // so Shopify computes it once on the subtotal and rounds. Replicate
        // that exactly: summing per-line floors under-counts the discount and
        // drifts a cent or two above the real checkout total.
        const subscriptionSubtotalCents = this.cart.subscriptions.reduce((total, dogSubscriptions) => {
          return (
            total +
            Object.values(dogSubscriptions).reduce((subtotal, { quantity, price }) => subtotal + quantity * price, 0)
          )
        }, 0)
        const discountedSubscriptionsCents =
          subscriptionSubtotalCents - Math.round((subscriptionSubtotalCents * discountPercentage) / 100)
        const oneTimeCents = Math.round(this.cart.oneTimePurchasesTotal * 100)

        this.totalPriceTarget.textContent = `€${((discountedSubscriptionsCents + oneTimeCents) / 100)
          .toFixed(2)
          .replace('.', ',')}`
      }

      seeIngredients(event) {
        this.dispatch('openIngredientsDrawer', { detail: { id: event.params.id.toString() } })
      }

      async proceedToCheckout() {
        this.#pushPreCheckoutCompletedEvent()
        window.location.href = await this.cart.prepareCheckoutUrl(this.dogs)
      }

      #pushFoodTypeSelectedEvent() {
        DogHeroes.pushToDataLayer({
          event: 'food_type_selected',
          quiz_type: 'dog',
          food_type: this.selectedRecipeType,
          dogs: [DogHeroes.serializeDog(this.dogs[this.selectedDogIndex])],
        })
      }

      // One recipe_selected per dog (Fosca's model): flat dog properties, the
      // recipes as text and the per-dog spend. Fired once all dogs have recipes.
      #pushRecipeSelectedEvents() {
        this.dogs.forEach((dog, index) => {
          let subscription = this.cart.subscriptions[index] || {}
          let recipes = Object.values(subscription)
          DogHeroes.pushToDataLayer({
            event: 'recipe_selected',
            quiz_type: 'dog',
            food_type: recipes[0]?.recipeType ?? this.selectedRecipeType,
            dogs: [DogHeroes.serializeDog(dog)],
            recipes: DogHeroes.recipesText(recipes),
            ...DogHeroes.dogPriceFields(recipes),
            ecommerce: DogHeroes.recipeEcommerce(subscription),
          })
        })
      }

      // Lightweight funnel marker before redirecting to checkout: the per-dog
      // detail is already in recipe_selected / extra_selected, so here we only
      // carry the order total (recipes + one-time extras).
      #pushPreCheckoutCompletedEvent() {
        DogHeroes.pushToDataLayer({
          event: 'pre_checkout_completed',
          quiz_type: 'dog',
          currency: 'EUR',
          total_price: this.#round2(this.cart.subscriptionsSubtotal / 100 + this.cart.oneTimePurchasesTotal),
        })
      }

      #round2(value) {
        return Math.round((value + Number.EPSILON) * 100) / 100
      }

      #renderBadges() {
        let { dog_breeds } = DogHeroes.algorithmData

        this.dogs.forEach((dog, index) => {
          let badgeContainer = this.badgeContainerTemplateTarget.cloneNode(true).content.firstElementChild
          this.badgeContainerTemplateTarget.insertAdjacentElement('afterend', badgeContainer)

          badgeContainer.dataset.index = index.toString()
          badgeContainer.style.display = index === 0 ? 'flex' : 'none'

          let { additional_breed, breed, allergies, activity, hunger } = dog
          let formattedData = [
            `${this.#breedName(breed, dog_breeds)} ${
              additional_breed ? `+ ${this.#breedName(additional_breed, dog_breeds)}` : ''
            }`,
            dog.age.inMonths > 14 ? 'Adulto' : 'Cucciolo',
            allergies.length > 0 ? 'Allergie: ' + allergies.join(', ') : 'No allergie',
            `Cane ${activity.replace(/-/g, ' ').replace(/_/g, ' ')}`,
            `Cane ${hunger.replace(/-/g, ' ').replace(/_/g, ' ')}`,
          ]

          formattedData.forEach((data) => {
            let badgeElement = this.badgeTemplateTarget.cloneNode(true).content.firstElementChild
            badgeElement.textContent = data
            badgeContainer.appendChild(badgeElement)
          })
        })
      }

      #renderDogsSelector() {
        if (this.dogs.length <= 1) return

        this.dogs.forEach((dog, index) => {
          let dogElement = this.dogTemplateTarget.cloneNode(true).content.firstElementChild
          dogElement.toggleAttribute('data-selected', index === 0)
          dogElement.textContent = dog.displayName
          dogElement.dataset.index = index.toString()
          this.dogTemplateTarget.parentNode.insertBefore(dogElement, this.dogTemplateTarget)
        })
      }

      #renderVariantPickers() {
        this.dogs.forEach((_, index) => {
          let variantPickerElement = this.variantPickerTemplateTarget.cloneNode(true).content.firstElementChild
          variantPickerElement.dataset.index = index.toString()
          if (index === 0) variantPickerElement.style.display = 'flex'
          this.variantPickerTemplateTarget.parentNode.insertBefore(
            variantPickerElement,
            this.variantPickerTemplateTarget
          )
        })
      }

      #renderHeader() {
        if (this.dogs.length <= 1) {
          this.multipleDogHeaderTarget.style.display = 'none'
          this.singleDogHeaderTarget.style.display = 'block'

          let headerTitles = this.singleDogHeaderTarget.children
          Array.from(headerTitles).forEach((header) => (header.style.display = 'none'))
          headerTitles[this.currentStep].style.display = 'block'
        } else {
          this.singleDogHeaderTarget.style.display = 'none'
          this.multipleDogHeaderTarget.style.display = ''
        }
      }

      #displayCorrectVariantPicker(index) {
        this.variantPickerTargets.forEach((el, elIndex) => {
          el.style.display = elIndex === index ? 'flex' : 'none'
        })
      }

      #renderCurrentStep() {
        this.stepTargets.forEach((step, index) => {
          step.classList.toggle('active', index === this.currentStep)
        })
        window.scrollTo(0, 0)
      }

      #renderSelectedRecipeType() {
        if (this.selectedRecipeType === 'frozen') {
          this.frozenRecipeTargets.forEach((el) => el.classList.remove('hidden'))
          this.pantryRecipeTargets.forEach((el) => el.classList.add('hidden'))
          this.pickerTitleTarget.textContent = 'surgelate'
        } else if (this.selectedRecipeType === 'pantry') {
          this.pantryRecipeTargets.forEach((el) => el.classList.remove('hidden'))
          this.frozenRecipeTargets.forEach((el) => el.classList.add('hidden'))
          this.pickerTitleTarget.textContent = 'da dispensa'
        }
      }

      #renderDogNamePlaceholders() {
        let dogNames = this.dogs
          .map((dog) => dog.name)
          .filter(Boolean)
          .join(', ')
        dogNames = dogNames.replace(/, ([^,]*)$/, ' e $1')

        this.element.querySelectorAll('[data-dog-name]').forEach((el) => {
          el.textContent = dogNames || 'il tuo cane'
        })
      }

      #breedName(handle, dogBreeds) {
        let breed = dogBreeds.find((breed) => breed.handle === handle)
        return breed ? breed.name : handle.replace(/-/g, ' ').replace(/^./, (c) => c.toUpperCase())
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--ui--age-input"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'dogheroes--ui--age-input',
    class extends Stimulus.Controller {
      static targets = [
        'birthdayType',
        'birthday',
        'absoluteSelector',
        'relativeSelector',
        'absolute',
        'relative',
        'relativeAgeYears',
        'relativeAgeMonths',
        'yearSelector',
        'monthSelector',
        'daySelector',
      ]

      connect() {
        this.render()
      }

      age() {
        return DogHeroes.Age.fromString(this.birthdayTarget.value)
      }

      // --- Custom select bridge ---

      selectController(target) {
        return this.application.getControllerForElementAndIdentifier(target, 'dogheroes--ui--select')
      }

      readSelect(target) {
        const hidden = target.querySelector('input[type="hidden"]')
        return hidden ? hidden.value : ''
      }

      writeSelect(target, value) {
        const controller = this.selectController(target)
        if (controller) {
          controller.setValue(value)
          return
        }
        const hidden = target.querySelector('input[type="hidden"]')
        if (hidden) hidden.value = value == null ? '' : String(value)
      }

      writeSelectOptions(target, options) {
        const controller = this.selectController(target)
        if (controller) {
          controller.setOptions(options)
          return
        }
        const list = target.querySelector('[role="listbox"]')
        if (!list) return
        list.innerHTML = options
          .map(
            (o) =>
              `<li class="item" role="option" data-value="${o.value}" data-action="click->dogheroes--ui--select#onItemClick">${o.label}</li>`
          )
          .join('')
      }

      // --- Render ---

      render() {
        let age = this.birthdayTarget.value ? this.age() : null
        let type = this.birthdayTypeTarget.value || 'relative'

        this.relativeAgeYearsTarget.value = age?.years || ''
        this.relativeAgeMonthsTarget.value = age?.months || ''
        this.writeSelect(this.yearSelectorTarget, age?.year || '')
        this.writeSelect(this.monthSelectorTarget, age?.month || '')

        if (type == 'relative') {
          this.relativeSelectorTarget.checked = true
          this.absoluteSelectorTarget.checked = false
          this.absoluteTarget.style.display = 'none'
          this.relativeTarget.style.display = 'block'
        } else {
          this.relativeSelectorTarget.checked = false
          this.absoluteSelectorTarget.checked = true
          this.absoluteTarget.style.display = 'block'
          this.relativeTarget.style.display = 'none'

          if (type == 'exact') {
            this.daySelectorTarget.style.display = ''
            this.updateDayOptions()
            if (age?.day) this.writeSelect(this.daySelectorTarget, age.day)
          } else if (type == 'approximate') {
            this.daySelectorTarget.style.display = 'none'
          } else {
            throw new Error(`Invalid birthday type: ${type}`)
          }
        }
      }

      updateDayOptions() {
        let age = this.age()
        if (!age) return
        let { year, month } = age
        let daysInMonth = this.getDaysInMonth(month, year)

        const options = []
        for (let value = 1; value <= daysInMonth; value++) {
          options.push({ value, label: String(value) })
        }
        this.writeSelectOptions(this.daySelectorTarget, options)
      }

      setAbsoluteBirthday() {
        let year = this.readSelect(this.yearSelectorTarget)
        let month = this.readSelect(this.monthSelectorTarget)
        let day = this.readSelect(this.daySelectorTarget)

        let age = new DogHeroes.Age(year, month, day)

        if (year || month) {
          let birthday = age.valueOf()
          this.birthdayTarget.value = birthday

          if (day) {
            this.birthdayTypeTarget.value = 'exact'
          } else {
            this.birthdayTypeTarget.value = 'approximate'
          }
        } else {
          this.birthdayTarget.value = ''
          this.birthdayTypeTarget.value = ''
        }

        this.render()
      }

      setRelativeBirthday() {
        const yearsInput = this.relativeAgeYearsTarget
        const monthsInput = this.relativeAgeMonthsTarget

        // Validate and clamp years (0–30)
        const rawYears = parseInt(yearsInput.value)
        if (!isNaN(rawYears)) {
          yearsInput.value = Math.min(Math.max(rawYears, 0), 30)
        } else {
          yearsInput.value = ''
        }

        // Validate and clamp months (0–11)
        const rawMonths = parseInt(monthsInput.value)
        if (!isNaN(rawMonths)) {
          monthsInput.value = Math.min(Math.max(rawMonths, 0), 11)
        } else {
          monthsInput.value = ''
        }

        const years = yearsInput.value
        const months = monthsInput.value

        if (years || months) {
          this.birthdayTarget.value = DogHeroes.Age.fromRelativeAge(years, months).valueOf()
          this.birthdayTypeTarget.value = 'relative'
        } else {
          this.birthdayTarget.value = ''
          this.birthdayTypeTarget.value = ''
        }

        this.render()
      }

      blockInvalidKeys(event) {
        if (['e', 'E', '+', '-'].includes(event.key)) {
          event.preventDefault()
        }
      }

      showRelative() {
        this.birthdayTypeTarget.value = 'relative'
        this.render()
      }

      showAbsolute() {
        this.birthdayTypeTarget.value = 'approximate'
        this.render()
      }

      toggleDaySelector() {
        if (this.daySelectorTarget.style.display === 'none') {
          this.birthdayTypeTarget.value = 'exact'
        } else {
          this.birthdayTypeTarget.value = 'approximate'
        }
        this.render()
      }

      getDaysInMonth(month, year) {
        let daysPerMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

        if (month === 2) {
          let isLeapYear = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
          return isLeapYear ? 29 : 28
        }

        return daysPerMonth[month - 1]
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--ui--allergy-checkboxes"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'dogheroes--ui--allergy-checkboxes',
    class extends Stimulus.Controller {
      static targets = ['noAllergy', 'allergy']

      disableOthers() {
        if (this.noAllergyTarget.checked) {
          this.allergyTargets.forEach((checkbox) => {
            checkbox.checked = false
          })
        }
      }

      toggle() {
        if (this.allergyTargets.some((checkbox) => checkbox.checked)) {
          this.noAllergyTarget.checked = false
        }
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--ui--flash-message"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'dogheroes--ui--flash-message',
    class extends Stimulus.Controller {
      dismiss() {
        this.element.remove()
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--ui--health-issues"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'dogheroes--ui--health-issues',
    class extends Stimulus.Controller {
      static targets = ['fieldset', 'checkbox', 'yes']

      connect() {
        this.toggle()
      }

      toggle() {
        if (this.yesTarget.checked) {
          this.fieldsetTarget.style.display = 'flex'
        } else {
          this.fieldsetTarget.style.display = 'none'
          this.checkboxTargets.forEach((checkbox) => {
            checkbox.checked = false
          })
        }
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--ui--select-breed"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'dogheroes--ui--select-breed',
    class extends Stimulus.Controller {
      static targets = ['search', 'hidden', 'list']
      static values = {
        isAdditional: {
          type: Boolean,
          default: false,
        },
      }
      static classes = ['selected', 'active']

      connect() {
        this.dogBreedsValue = DogHeroes.algorithmData.dog_breeds
        let savedDogBreedHandle = this.hiddenTarget.value || ''
        if (!savedDogBreedHandle && this.element.dataset.dogIndex) {
          let dog = DogHeroes.Dog.find(this.element.dataset.dogIndex)
          savedDogBreedHandle = (this.isAdditionalValue ? dog?.additional_breed : dog?.breed) || ''
        }
        this.searchTarget.value = this.dogBreedsValue.find((b) => b.handle === savedDogBreedHandle)?.name || ''
        this.breeds = []
        this.filteredBreeds = []
        this.isOpen = false
        this.activeIndex = -1

        this.handleClickOutside = this.handleClickOutside.bind(this)
        document.addEventListener('click', this.handleClickOutside)

        this.fetchBreeds(this.dogBreedsValue)
        this.renderSelectedBreed()
        this.dispatch('connected')
      }

      disconnect() {
        document.removeEventListener('click', this.handleClickOutside)
      }

      // --- Data ---

      fetchBreeds(dog_breeds) {
        const sorted = [...dog_breeds].sort((a, b) => a.name.localeCompare(b.name))
        const meticcioIndex = sorted.findIndex((b) => b.handle === 'meticcio')
        if (meticcioIndex > -1) {
          const [meticcio] = sorted.splice(meticcioIndex, 1)
          sorted.unshift(meticcio)
        }
        this.breeds = sorted
        this.filteredBreeds = [...this.breeds]
      }

      // --- Open / Close ---

      open() {
        if (this.isOpen) return
        this.isOpen = true
        this.listTarget.hidden = false
        this.searchTarget.setAttribute('aria-expanded', 'true')
        if (this.activeIndex > this.filteredBreeds.length - 1) this.activeIndex = 0
      }

      close() {
        if (!this.isOpen) return
        this.isOpen = false
        this.activeIndex = -1
        this.listTarget.hidden = true
        this.searchTarget.setAttribute('aria-expanded', 'false')
        this.searchTarget.removeAttribute('aria-activedescendant')
      }

      // --- Events ---

      onFocus() {
        this.filter()
        this.renderList()
        this.open()
      }

      onBlur() {
        this.close()
      }

      onInput() {
        this.searchTarget.value = this.searchTarget.value.replace(/^ +/, '').replace(/  +/g, ' ').replace(/\./g, '')
        this.clearSelection()
        this.filter()
        this.activeIndex = 0
        this.renderList()
        this.open()
      }

      moveDown() {
        this.moveActive(1)
      }

      moveUp() {
        this.moveActive(-1)
      }

      onKeydown(event) {
        switch (event.key) {
          case 'ArrowDown':
            event.preventDefault()
            this.moveActive(1)
            break
          case 'ArrowUp':
            event.preventDefault()
            this.moveActive(-1)
            break
          case 'Enter':
            if (this.searchTarget.getAttribute('aria-expanded') === 'true') {
              event.preventDefault()
              event.stopPropagation()
              if (this.activeIndex >= 0 && this.activeIndex < this.filteredBreeds.length) {
                this.select(this.filteredBreeds[this.activeIndex])
                this.close()
              }
            }
            break
          case 'Escape':
            this.close()
            this.searchTarget.blur()
            break
          case ' ':
            if (this.searchTarget.value.endsWith(' ')) {
              event.preventDefault()
            }
            break
          case '.':
            event.preventDefault()
            break
        }
      }

      onClear() {
        this.clearSelection()
        this.searchTarget.value = ''
        this.filter()
        this.renderList()
        this.searchTarget.focus()
      }

      handleClickOutside(event) {
        if (!this.element.contains(event.target)) {
          this.close()
        }
      }

      // --- Filtering ---

      filter() {
        const query = this.searchTarget.value.trim().toLowerCase()

        if (query === '') {
          this.filteredBreeds = [...this.breeds]
        } else {
          this.filteredBreeds = this.breeds.filter((breed) => breed.name.toLowerCase().includes(query))
        }
      }

      // --- Selection ---

      renderSelectedBreed() {
        const selectedHandle = this.hiddenTarget.value
        const selectedBreed = this.breeds.find((b) => b.handle === selectedHandle)
        this.searchTarget.value = selectedBreed ? selectedBreed.name : ''
        if (selectedBreed) {
          this.searchTarget.classList.add(this.selectedClass)
          this.close()
        } else {
          this.searchTarget.classList.remove(this.selectedClass)
        }
      }

      select(breed) {
        this.hiddenTarget.value = breed.handle
        this.renderSelectedBreed()
        this.hiddenTarget.dispatchEvent(new Event('change', { bubbles: true }))

        if (this.isAdditionalValue) {
          const form = this.element.closest('form')
          const nextButton = form?.querySelector('[data-quiz-target="nextButton"]')
          if (nextButton) nextButton.focus()
        }
      }

      clearSelection() {
        this.hiddenTarget.value = ''
        this.searchTarget.classList.remove(this.selectedClass)
      }

      // --- Keyboard navigation ---

      moveActive(direction) {
        if (this.filteredBreeds.length === 0) return

        this.activeIndex += direction

        if (this.activeIndex < 0) this.activeIndex = this.filteredBreeds.length - 1
        if (this.activeIndex >= this.filteredBreeds.length) this.activeIndex = 0

        this.updateActiveOption()
      }

      updateActiveOption() {
        const items = this.listTarget.querySelectorAll("[role='option']:not([aria-disabled])")

        items.forEach((item, index) => {
          if (index === this.activeIndex) {
            item.classList.add(this.activeClass)
            item.scrollIntoView({ block: 'nearest' })
            this.searchTarget.setAttribute('aria-activedescendant', item.id)
          } else {
            item.classList.remove(this.activeClass)
          }
        })
      }

      // --- Rendering ---

      renderList() {
        const listEl = this.listTarget
        listEl.innerHTML = ''

        if (this.filteredBreeds.length === 0) {
          const emptyLi = document.createElement('li')
          emptyLi.classList.add('item', 'item--empty')
          emptyLi.textContent = 'Nessun risultato trovato'
          emptyLi.setAttribute('role', 'option')
          emptyLi.setAttribute('aria-disabled', 'true')
          listEl.appendChild(emptyLi)
          return
        }

        const fragment = document.createDocumentFragment()

        this.filteredBreeds.forEach((breed, index) => {
          const li = document.createElement('li')
          li.id = `breed-option-${breed.handle}`
          li.classList.add('item')
          li.textContent = breed.name
          li.setAttribute('role', 'option')
          li.setAttribute('aria-selected', this.hiddenTarget.value === breed.handle)

          li.addEventListener('mousedown', (e) => e.preventDefault())
          li.addEventListener('click', () => this.select(breed))

          if (index === this.activeIndex) {
            li.classList.add('item--active')
          }

          fragment.appendChild(li)
        })

        listEl.appendChild(fragment)
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--ui--select"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'dogheroes--ui--select',
    class extends Stimulus.Controller {
      static targets = ['trigger', 'list', 'hidden']

      connect() {
        this.isOpen = false
        this.activeIndex = -1
        this.handleClickOutside = this.handleClickOutside.bind(this)
        document.addEventListener('click', this.handleClickOutside)
        this.renderTrigger()
        this.renderSelectedState()
      }

      disconnect() {
        document.removeEventListener('click', this.handleClickOutside)
      }

      get value() {
        return this.hiddenTarget.value
      }

      setValue(v) {
        const next = v == null ? '' : String(v)
        if (this.hiddenTarget.value === next) {
          this.renderTrigger()
          this.renderSelectedState()
          return
        }
        this.hiddenTarget.value = next
        this.renderTrigger()
        this.renderSelectedState()
      }

      setOptions(options) {
        const previousValue = this.hiddenTarget.value
        this.listTarget.innerHTML = ''
        const fragment = document.createDocumentFragment()
        options.forEach((opt) => {
          const li = document.createElement('li')
          li.classList.add('item')
          li.setAttribute('role', 'option')
          li.dataset.value = String(opt.value)
          li.textContent = opt.label
          li.dataset.action = 'click->dogheroes--ui--select#onItemClick'
          fragment.appendChild(li)
        })
        this.listTarget.appendChild(fragment)
        if (!this.optionExists(previousValue)) this.hiddenTarget.value = ''
        this.renderTrigger()
        this.renderSelectedState()
      }

      optionExists(value) {
        if (value === '') return true
        return Array.from(this.listTarget.querySelectorAll('[role="option"]')).some(
          (li) => li.dataset.value === String(value)
        )
      }

      onItemClick(event) {
        const li = event.currentTarget
        this.select(li.dataset.value)
      }

      select(value) {
        this.hiddenTarget.value = String(value)
        this.renderTrigger()
        this.renderSelectedState()
        this.hiddenTarget.dispatchEvent(new Event('change', { bubbles: true }))
        this.close()
        this.triggerTarget.focus()
      }

      toggle(event) {
        event.preventDefault()
        // Safari/Chrome on macOS don't focus <button> on click, which kills
        // keyboard navigation after a mouse-driven open.
        this.triggerTarget.focus()
        this.isOpen ? this.close() : this.open()
      }

      open() {
        if (this.isOpen) return
        this.isOpen = true
        this.listTarget.hidden = false
        this.triggerTarget.setAttribute('aria-expanded', 'true')
        this.element.classList.add(`${this.identifier}--open`)
        this.activeIndex = this.currentIndex()
        this.updateActive()
        this.triggerTarget.focus()
      }

      close() {
        if (!this.isOpen) return
        this.isOpen = false
        this.activeIndex = -1
        this.listTarget.hidden = true
        this.triggerTarget.setAttribute('aria-expanded', 'false')
        this.element.classList.remove(`${this.identifier}--open`)
        this.updateActive()
      }

      handleClickOutside(event) {
        if (!this.element.contains(event.target)) this.close()
      }

      onKeydown(event) {
        const items = this.listTarget.querySelectorAll('[role="option"]')
        if (!this.isOpen) {
          if (['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(event.key)) {
            event.preventDefault()
            event.stopPropagation()
            this.open()
            this.activeIndex = this.currentIndex() < 0 ? 0 : this.currentIndex()
            this.updateActive()
          }
          return
        }
        switch (event.key) {
          case 'ArrowDown':
            event.preventDefault()
            event.stopPropagation()
            this.activeIndex = items.length === 0 ? -1 : (this.activeIndex + 1) % items.length
            this.updateActive()
            break
          case 'ArrowUp':
            event.preventDefault()
            event.stopPropagation()
            this.activeIndex = items.length === 0 ? -1 : (this.activeIndex - 1 + items.length) % items.length
            this.updateActive()
            break
          case 'Home':
            event.preventDefault()
            event.stopPropagation()
            this.activeIndex = 0
            this.updateActive()
            break
          case 'End':
            event.preventDefault()
            event.stopPropagation()
            this.activeIndex = items.length - 1
            this.updateActive()
            break
          case 'Enter':
          case ' ':
            event.preventDefault()
            event.stopPropagation()
            if (this.activeIndex >= 0 && items[this.activeIndex]) {
              this.select(items[this.activeIndex].dataset.value)
            }
            break
          case 'Escape':
            event.preventDefault()
            event.stopPropagation()
            this.close()
            break
          case 'Tab':
            this.close()
            break
        }
      }

      currentIndex() {
        const value = this.hiddenTarget.value
        const items = Array.from(this.listTarget.querySelectorAll('[role="option"]'))
        return items.findIndex((li) => li.dataset.value === value)
      }

      renderTrigger() {
        const placeholder = this.triggerTarget.dataset.selectPlaceholder || ''
        const value = this.hiddenTarget.value
        const items = this.listTarget.querySelectorAll('[role="option"]')
        let label = placeholder
        let hasValue = false
        items.forEach((li) => {
          if (li.dataset.value === value && value !== '') {
            label = li.textContent
            hasValue = true
          }
        })
        this.triggerTarget.textContent = label
        this.triggerTarget.classList.toggle(`${this.identifier}__trigger--placeholder`, !hasValue)
      }

      renderSelectedState() {
        const value = this.hiddenTarget.value
        const items = this.listTarget.querySelectorAll('[role="option"]')
        items.forEach((li) => {
          li.setAttribute('aria-selected', li.dataset.value === value ? 'true' : 'false')
        })
      }

      updateActive() {
        const items = this.listTarget.querySelectorAll('[role="option"]')
        items.forEach((li, i) => {
          if (i === this.activeIndex) {
            li.classList.add('item--active')
            li.scrollIntoView({ block: 'nearest' })
          } else {
            li.classList.remove('item--active')
          }
        })

        // Point the combobox at the highlighted option so screen readers
        // announce it during arrow-key navigation (focus stays on the trigger).
        const active = items[this.activeIndex]
        if (active) {
          if (!active.id) active.id = `${this.listTarget.id}-opt-${this.activeIndex}`
          this.triggerTarget.setAttribute('aria-activedescendant', active.id)
        } else {
          this.triggerTarget.removeAttribute('aria-activedescendant')
        }
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--ui--slider-input"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('range-slider')) {
    class RangeSlider extends HTMLElement {
      connectedCallback() {
        this.object = JSON.parse(this.dataset.object || '{}')
        if (Object.keys(this.object).length === 0) return

        this.numberOfSteps = this.object.steps
        this.total = 100
        this.stepValue = this.total / (this.numberOfSteps - 1)
        this.currentIndexStep = 0

        this.images = this.querySelectorAll('.range-slider-image')
        this.titleText = this.querySelector('[ref="title"]')
        this.descriptionText = this.querySelector('[ref="description"]')
        this.inputQuiz = this.querySelector('[ref="hidden_input"]')

        this.rangeInput = this.querySelector('[ref="input"]')

        this.bindEvents()
        this.selectByHandle() || this.updateFromSliderValue()
      }

      selectByHandle() {
        let selectedHandle = this.dataset.selectedHandle
        if (!selectedHandle) return false

        let index = this.object.items.findIndex((item) => item.handle === selectedHandle)
        if (index === -1) return false

        this.currentIndexStep = index
        this.rangeInput.value = index * this.stepValue
        this.updateUI()
        return true
      }

      bindEvents() {
        this.rangeInput.addEventListener('input', () => this.handleSliderInput())
        this.images.forEach((img, index) => {
          img.addEventListener('click', () => this.handleImageClick(index))
          img.style.cursor = 'pointer'
        })
      }

      handleSliderInput() {
        const sliderValue = parseInt(this.rangeInput.value, 10)
        this.currentIndexStep = Math.round(sliderValue / this.stepValue)
        this.updateUI()
      }

      handleImageClick(index) {
        this.currentIndexStep = index
        this.rangeInput.value = index * this.stepValue
        this.updateUI()

        this.rangeInput.dispatchEvent(new Event('input', { bubbles: true }))
        this.rangeInput.dispatchEvent(new Event('change', { bubbles: true }))
      }

      updateFromSliderValue() {
        const sliderValue = parseInt(this.rangeInput.value, 10)
        this.currentIndexStep = Math.round(sliderValue / this.stepValue)
        this.updateUI()
      }

      updateUI() {
        this.updateImageVisibility()
        this.updateText()
        this.updateInputValue()
      }

      updateImageVisibility() {
        this.images.forEach((img, index) => {
          const isActive = index === this.currentIndexStep
          img.classList.toggle('blurred', !isActive)
          img.classList.toggle('active', isActive)
        })
      }

      updateText() {
        const currentItem = this.object.items[this.currentIndexStep]

        if (this.titleText) this.titleText.textContent = currentItem.label
        if (this.descriptionText) this.descriptionText.textContent = currentItem.description

        // Announce the human-readable option (e.g. "Peso ideale") instead of the
        // raw numeric slider value, which is meaningless on its own.
        if (this.rangeInput) this.rangeInput.setAttribute('aria-valuetext', currentItem.label)
      }

      updateInputValue() {
        const currentItem = this.object.items[this.currentIndexStep]

        if (this.inputQuiz) this.inputQuiz.value = currentItem.handle
      }
    }

    customElements.define('range-slider', RangeSlider)
  }
  } catch(e) { console.error(e); }
})();

})();
